import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';

import { Modal } from 'react-bootstrap';
import Select from 'react-select'
import DatePicker from "react-datepicker"

import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api';
import { checkPermission, chequeStatusName, formatDate, formatMoney, formatMoneyInput } from 'helpers/helpers';
import DrawingModal from './DrawingModal'
import { tierMarkup } from './drawingGeometry';

import Cheque from '../../../components/Cheque';
import { toast } from 'react-toastify';
import CustomTooltip from 'pages/parts/CustomTooltip';
import DeleteModal from 'pages/parts/DeleteModal';
import useDidMountEffect from 'pages/parts/useDidMountEffect';
// import MaskedInput from 'react-text-mask';

function Cashbox() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()
	const location = useLocation()
	const dispatch = useDispatch()

	const printChequeRef = useRef(null);
	const refs = useRef([]);
	const inputRefs = useRef([]);
	const rollSelectRefs = useRef([]);
	const sizeRefs = useRef([]);
	/* MAHSULOT NOMI selekti (2026-08-13). Aksessuarda Tab bosilganda
	   fokus yangi qatorning NOM maydoniga tushishi kerak — profnastildagidek
	   hajm maydoniga emas (izoh: `addToList`). */
	const productSelectRefs = useRef([]);

	const handlePrint = useReactToPrint({
		content: () => printChequeRef.current,
	});

	const reduxAccount = useSelector(state => state.account)
	const reduxCashbox = useSelector(state => state.cashbox)
	const reduxTransferData = useSelector(state => state.transferData)

	const [activeTab, setActiveTab] = useState(1);
	const [activeRowIndex, setActiveRowIndex] = useState(0);

	const initData = {
		'cashier_name': reduxAccount.name,
		'cashier_phone': reduxAccount.phone,
		'paid': '',
		'selectedPaymentType': 'cash',
		'status': 1,
		'selectedProduct': {},
		'total': {
			1: {},
			3: {},
			4: {},
			5: {},
		},
		'products': [],
		'payments': reduxCashbox.paymentTypes.map(p => ({ ...p })),
		'paymentsCopy': reduxCashbox.paymentTypes.map(p => ({ ...p })),
		'parent_id': location.state?.parent_id || null,
		'client_id': location.state?.client_id || null,
		'delivery_type_id': location.state?.delivery_type_id || null,
		'address': location.state?.address || null,
		'region_id': location.state?.region_id || null,
		// Tўлов режаси — pul qanday keladi. Sotuvchi chek yozayotganda belgilaydi,
		// keyin ro'yxatdan shu bo'yicha filtrlab topiladi.
		'payment_plan': null,
	};

	// 4 ta reja. FAQAT 'nasiya'da qarz/nasiya sanasi so'raladi.
	// cash / half / driver — sanasiz, "Saqlash" bilan darhol tugaydi (user qarori 2026-07-16).
	const PAYMENT_PLANS = [
		{ key: 'cash', i18n: 'plan_cash', icon: '💵' },
		{ key: 'half', i18n: 'plan_half', icon: '🧾' },
		{ key: 'nasiya', i18n: 'plan_nasiya', icon: '📅' },
		{ key: 'driver', i18n: 'plan_driver', icon: '🚚' },
	];
	const planNeedsDebtDate = (plan) => ['nasiya'].includes(plan);

	const [data, setData] = useState({ ...initData })

	// СКИДКА (5-kategoriya) — yagona qo'lda kiritiladigan to'lov maydoni.
	// Qolganlari: Насия avtomatik, Накд/Банк/P2P esa ₴ tugmasi orqali olinadi.
	const discountIndex = (data.payments || []).findIndex(p => Number(p.payment_type_category_id) === 5)
	const [modalDebtDate, setModalDebtDate] = useState({ 'show': false });
	const [modalQuantity, setModalQuantity] = useState({ 'show': false });
	const [modalSelectProduct, setModalSelectProduct] = useState({ 'show': false });
	// AKSESSUAR CHIZMASI — qaysi qator uchun ochilgan
	const [drawModal, setDrawModal] = useState({ show: false, index: -1 });
	// Aksessuarga biriktirilgan chizma shablonlari
	const [accTemplates, setAccTemplates] = useState([]);
	const [modalDelete, setModalDelete] = useState({ 'show': false });
	const [modalUser, setModalUser] = useState({ 'show': false });
	const [modalSearchUser, setModalSearchUser] = useState({ 'show': false });
	const [modalConfirm, setModalConfirm] = useState({ 'show': false });
	const [products, setProducts] = useState({
		'rolls': [],
		'shapes': [],
		'products': [],
		'categories': [],
		'accessories': [],
	})
	const [chequeStatuses, setChequeStatuses] = useState([])
	const [clients, setClients] = useState([])
	const [regions, setRegions] = useState([])
	/* Kassadan hudud qo'shish oynasi — sotuvchi mijozning mahallasini ro'yxatda
	   topmasa shu yerda qo'shadi (2026-08-11). */
	const [regionModal, setRegionModal] = useState({ show: false, name: '', type: 'zona', parent_id: null })
	const [deliveryTypes, setDeliveryTypes] = useState([])
	const [clientTypes, setClientTypes] = useState([])
	const [currentCurrency, setCurrentCurrency] = useState(0)
	const [chequeSubmitting, setChequeSubmitting] = useState(false) // dublikat chek himoyasi
	/* CHEREPITSA UMUMIY boshi/shag (2026-08-27, egasi: «10 xil razmer bo'lsa har
	   biriga yozish noqulay — umumiy qilaylik, lekin o'zida ham o'zgartirish
	   imkoni qolsin»). Bu FAQAT to'ldirish quroli: bazaga qator qiymatlari
	   yoziladi, umumiy qiymatning o'zi saqlanmaydi. clearData() da tozalanadi —
	   keyingi mijozning chekiga oldingi mijoz shagi ilashib qolmasin. */
	const [tileDefault, setTileDefault] = useState({ start: '', step: '' })
	// Zakaz sanasi tavsiyasi (full tarif) — navbatga qarab hisoblanadi
	const [deliverySuggestion, setDeliverySuggestion] = useState(null)

	// Qator qoldiqdan oshib ketganmi (tanlangan rulon partiyasiga nisbatan)
	function isOverStock(p) {
		if (!p) return false
		const pt = Number(p.product_type)
		if (p.is_prepared) return Number(p.quantity) > Number(p.actual_balance || 0)
		if (pt === 4) return Number(p.metr) > Number(p.actual_balance || 0)
		if (pt === 3 || pt === 5) return Number(p.roll_metr) > Number(p.actual_balance || 0)
		if (pt === 1) return Number(p.quantity) > Number(p.balance || 0)
		return false
	}

	// Rulon tanlash oynasidagi QARZ qatori: sotiladigan (ochilgan + qoldiqli) partiya
	// qolmagan rulon. Backend uni tugagan eng oxirgi partiya qatori sifatida yuboradi
	// (HelperController::products), ya'ni ustunlardagi ID / Сони / Сана / Очди — ESKI,
	// allaqachon tugagan partiyaniki. Sotuvchi ularni yangi rulonniki deb o'qimasligi
	// uchun ular bo'sh ko'rsatiladi; kg/metr nisbati esa taxminiy («≈»), chunki keladigan
	// rulonning tonnasi boshqacha bo'lishi mumkin.
	function isBackorderRow(item) {
		return Number(item?.actual_balance ?? item?.balance ?? 0) <= 0
	}

	async function createCheque(checkDebt = true) {
		if (chequeSubmitting) return // tez ikki bosishda ikkita chek yaratilmasin
		var dataCopy = { ...data }

		// T11: bo'sh qatorlar (mahsulot tanlanmagan) chekka YOZILMASIN; tanlangan qatorda miqdor > 0 bo'lsin.
		const filledRows = (data.products || []).filter(p => p.product_id)
		if (filledRows.length === 0) {
			return toast.error(t('add_products'));
		}
		const zeroQtyRow = filledRows.find(p => !(Number(p.quantity) > 0))
		if (zeroQtyRow) {
			return toast.error("Har bir mahsulot qatorida miqdor 0 dan katta bo'lishi kerak");
		}
		/* NOSTANDART AKSESSUAR CHIZMASIZ SOTILMASIN.
		   Uning kengligi CHIZMADAN chiqadi. Sotuvchi chizma oynasini chizmay
		   yopib qo'ysa, kenglik 0 bo'lib narx ham 0 bo'lib ketardi. */
		const noDraw = canDraw && filledRows.find(p => p.needs_drawing && !(Number(p.draw_width) > 0))
		if (noDraw) {
			return toast.error(t('drawing_required_for', { name: noDraw.product_name || '' }));
		}
		dataCopy.products = filledRows
		if (!data.client_id) {
			return toast.error(t('select_client'));
		}
		if (data.paid <= 0 && data.discount_amount <= 0 && data.debt_amount <= 0) {
			return toast.error(t('fill_payment_type_field'));
		}
		/* SMENA OCHIQ BO'LMASA SOTUV YO'Q (2026-08-15, korxona egasining talabi).
		   Backend ham buni tekshiradi (ChequeController::store) — bu yerdagisi
		   xodim serverga borib-kelmasdan darhol ko'rsin uchun.
		   ⚠️ Smena KORXONAGA bitta: uni odatda egasi ochadi va hamma sotuvchi
		      o'shanga qo'shiladi. Ya'ni bu xabar «o'z smenangni och» degani emas —
		      korxonada umuman ochiq smena yo'qligini bildiradi. */
		if (!reduxAccount.shift?.id) {
			return toast.error(t('shift_required'));
		}
		if ((data.status === 2 || data.status === 3) && !data.delivery_date) {
			return toast.error(t('delivery_date_required'));
		}
		/* ZAKAZ MUDDATI — tizim tavsiyasi FAQAT TAVSIYA (2026-08-29, egasining
		   qarori: «majburlashni olib tashla, prosta tavsiya bersin, sabab yozmasin,
		   belgilagan kuniga saqlanib ketaversin»). Ilgari tavsiyadan ertaroq sana
		   qo'yilsa window.prompt bilan sabab so'ralar va yozilmasa saqlanmasdi —
		   OLIB TASHLANDI. Tavsiya sanasi va navbat tahlil uchun chek bilan
		   saqlanishda davom etadi (pastda suggested_delivery_date/queue_at_order),
		   `delivery_override_reason` endi doim bo'sh. */
		// Tўлов режаси majburiy — sotuvchi "pul qanday keladi"ni belgilashi shart,
		// aks holda chekni keyin ro'yxatdan topib bo'lmaydi.
		if (!data.payment_plan) {
			return toast.error(t('payment_plan_required'));
		}
		// Hudud majburiy — FAQAT yangi chekda (eski chek tahririni bloklamaydi va
		// mijozning mavjud hududini jimgina qayta yozib yubormaydi). id bo'lsa = tahrirlash.
		if (!id && !data.region_id) {
			return toast.error(t('region_required'));
		}
		// Qarz qoladigan rejalarda (yarim / nasiya / shofyordan) muddat bo'lishi shart
		if (planNeedsDebtDate(data.payment_plan) && !data.debt_date) {
			return toast.error(t('debt_date_required'));
		}

		// Qarz sana modali FAQAT Насия rejasида (cash/half/driver — sanasiz saqlanadi).
		// (Насия tanlanganда sana yuqoridagi maydondan kiritiladi — u holda 145-qatorda tekshiriladi.)
		if (checkDebt && !id && !data.debt_date && planNeedsDebtDate(data.payment_plan)) {
			var payment = dataCopy.payments.find(item => item.payment_type_category_id === 3 && item.amount > 0)
			if (payment?.amount > 0) {
				setData({ ...data, debt_date: new Date() })
				setModalDebtDate({ show: true })
				return;
			}
		}

		dataCopy.shift_id = reduxAccount.shift?.id;

		// Ogohlantirish: biror qatorda tanlangan rulon partiyasi qoldig'i yetarli emas (manfiy).
		// Yetishmagani boshqa OCHILGAN rulondan ayiriladi yoki "Rulon qarzi" (kutilayotgan)ga o'tadi.
		const shortLines = (data.products || []).filter(p => p.show && isOverStock(p))
		if (shortLines.length > 0) {
			toast.info("Diqqat: ba'zi rulonlarda qoldiq yetarli emas — yetishmagani boshqa ochilgan rulondan yoki «Rulon qarzi»ga o'tadi.")
		}

		// location.state?.parent_id har doim saqlansin (data.parent_id yo'qolib qolgan bo'lsa ham)
		if (location.state?.parent_id) {
			dataCopy.parent_id = location.state.parent_id;
		}

		/* ZAKAZ MUDDATI TAHLILI uchun: tizim tavsiyasi va o'sha paytdagi navbat
		   chek bilan birga saqlanadi. Busiz keyin «tavsiya to'g'ri chiqdimi» va
		   «kim tavsiyadan chetga chiqyapti» degan savollarga javob bo'lmaydi. */
		if (canPlanDelivery && deliverySuggestion) {
			dataCopy.suggested_delivery_date = deliverySuggestion.suggested_date
			dataCopy.queue_at_order = deliverySuggestion.queue
			if (data.delivery_override_reason) {
				dataCopy.delivery_override_reason = data.delivery_override_reason
			}
		}

		var response;
		setChequeSubmitting(true)
		try {
			if (id) {
				response = await PUT('/cheques', dataCopy, { loader: true })
			} else {
				dataCopy.currency = currentCurrency;
				response = await POST('/cheques', dataCopy, { loader: true })
			}

			if (httpOk(response)) {
				clearData()
				navigate(location.state?.parent_id ? '/cashbox' : -1)
			};
		} finally {
			setChequeSubmitting(false)
		}
	}

	function printCheque(a4 = false) {
		// Chekda MANZIL sifatida tanlangan hudud nomi chiqadi (backend show() da client_region).
		// Bu yerda chek hali SAQLANMAGAN bo'lishi mumkin — u holda backenddan hech narsa kelmaydi,
		// shuning uchun nomni mahalliy hududlar ro'yxatidan olamiz (aks holda manzil bo'sh chiqardi).
		const regionName = regions.find(r => r.id === data.region_id)?.name ?? data.client_region ?? null
		setData({ ...data, a4: a4, client_region: regionName })

		setTimeout(() => {
			handlePrint()
		}, 200);
	}

	function clearData() {
		setData(structuredClone(initData))
		// CHEREPITSA umumiy boshi/shag — yangi chek yangi mijoz, eski qiymat qolmasin
		setTileDefault({ start: '', step: '' })
		if (modalConfirm.show) setModalConfirm({ show: false })
		saveTransferData(initData)
	}

	function calculateTotalAmount(dataCopy) {
		var change = 0
		var paid = 0
		dataCopy.discount_amount = 0;
		dataCopy.debt_amount = 0;
		dataCopy.total_amount = 0;

		const totals = {
			1: { amount: 0, quantity: 0, },
			3: { amount: 0, metr: 0, roll_metr: 0, },
			4: { amount: 0, metr: 0, },
			5: { amount: 0, metr: 0, roll_metr: 0, kv_metr: 0, }
		};

		// dataCopy.corrugation_total_amount = 0;
		// dataCopy.accessory_total_amount = 0;
		// dataCopy.product_total_amount = 0;
		// dataCopy.tunicophone_total_amount = 0;

		for (let i = 0; i < dataCopy?.payments?.length; i++) {
			if (dataCopy.payments[i]['payment_type_category_id'] === 3) {
				dataCopy.debt_amount += Number(dataCopy.payments[i]['amount'])
			}
			if (dataCopy.payments[i]['payment_type_category_id'] !== 5 && dataCopy.payments[i]['payment_type_category_id'] !== 3) {
				paid += Number(dataCopy.payments[i]['amount'])
			} else if (dataCopy.payments[i]['payment_type_category_id'] === 5) {
				dataCopy.discount_amount += Number(dataCopy.payments[i]['amount']);
			}
		}

		for (let i = 0; i < dataCopy?.products?.length; i++) {
			// if (dataCopy?.products[i].product_type === 3) {
			// 	dataCopy.products[i]['accessory_sale_price'] = Math.round((Number(dataCopy.products[i]['sale_price'] ?? 0) + Number(dataCopy.products[i]['markup'] ?? 0)))
			// 	dataCopy.products[i]['accessory_sale_price'] = Math.round(Number(dataCopy.products[i]['accessory_sale_price']) * Number(dataCopy.products[i]['roll_metr'] ?? 0))
			// }

			if (dataCopy?.products[i].product_type === 1) {
				dataCopy.products[i]['total_price'] = Math.round(dataCopy.products[i]['sale_price'] * dataCopy.products[i]['quantity']);
			} else if (dataCopy?.products[i].is_prepared) {
				dataCopy.products[i]['total_price'] = Math.round(Number(dataCopy.products[i]['sale_price']) * Number(dataCopy.products[i]['quantity']));
			} else if (dataCopy?.products[i].product_type === 3 || dataCopy?.products[i].product_type === 5) {
				dataCopy.products[i]['total_price'] = Math.round(Number(dataCopy.products[i]['accessory_total_price']));
			} else {
				dataCopy.products[i]['total_price'] = Math.round(Number(dataCopy.products[i]['sale_price']) * Number(dataCopy.products[i]['metr']));
			}


			dataCopy.total_amount = dataCopy.total_amount + Number(dataCopy.products[i]['total_price']);

			const product = dataCopy?.products[i];
			const type = product.product_type;
			if (totals[type]) {
				totals[type].amount += Number(product.total_price || 0);
				totals[type].metr += Number(product.metr || 0);
				totals[type].roll_metr += Number(product.roll_metr || 0);
				totals[type].kv_metr += Number(product.kv_metr || 0);
				totals[type].quantity += Number(product.quantity || 0);
			}

			// if (dataCopy?.products[i].product_type === 1) {
			// 	dataCopy.product_total_amount = dataCopy.product_total_amount + Number(dataCopy.products[i]['total_price']);
			// }
			// if (dataCopy?.products[i].product_type === 3) {
			// 	dataCopy.accessory_total_amount = dataCopy.accessory_total_amount + Number(dataCopy.products[i]['total_price']);
			// }
			// if (dataCopy?.products[i].product_type === 4) {
			// 	dataCopy.corrugation_total_amount = dataCopy.corrugation_total_amount + Number(dataCopy.products[i]['total_price']);
			// }
			// if (dataCopy?.products[i].product_type === 5) {
			// 	dataCopy.tunicophone_total_amount = dataCopy.tunicophone_total_amount + Number(dataCopy.products[i]['total_price']);
			// }
		}

		dataCopy.total = totals;

		if (dataCopy.delivery_price) {
			dataCopy.total_amount += Number(dataCopy.delivery_price);
		}
		if (dataCopy?.discount_amount) {
			dataCopy.total_amount -= Number(dataCopy.discount_amount);
		}

		// ── НАСИЯ (qarz) AVTOMATIK ────────────────────────────────────────────────
		// Pul endi chek YOZILGANDA emas, OLINGANDA kiritiladi (cheklar ro'yxatidagi ₴ tugmasi).
		// Shuning uchun kassir "Насия" ni qo'lda yozmaydi — u shu yerda o'zi hisoblanadi:
		//     qarz = jami (chegirmadan keyin) − allaqachon to'langan
		// Eski chekni tahrirlaganda `paid` haqiqiy qiymat bo'ladi -> to'langan pul yo'qolmaydi.
		const autoDebt = Math.max(Number(dataCopy.total_amount) - Number(paid), 0)
		dataCopy.payments = (dataCopy.payments || []).map(p =>
			Number(p.payment_type_category_id) === 3 ? { ...p, amount: autoDebt } : p
		)
		dataCopy.debt_amount = autoDebt

		if (paid > dataCopy.total_amount) {
			var temporaryChange = Number(paid) - Number(dataCopy.total_amount)
			if (temporaryChange > 0) {
				change = temporaryChange
			} else {
				change = 0
			}
		}

		dataCopy.entity_debtor_amount = 0;
		if (dataCopy.entity_debtor_id) {
			if (paid >= dataCopy.total_amount) {
				dataCopy.entity_debtor_id = null
				dataCopy.entity_debtor_name = null
				dataCopy.entity_debtor_type = null
				dataCopy.entity_debtor_amount = 0
			} else {
				dataCopy.entity_debtor_amount =
					dataCopy.total_amount -
					paid -
					dataCopy.temporaryDiscount
			}
		}

		var totalPayments = (
			Number(paid) +
			Number(dataCopy.temporaryDiscount)
		)

		dataCopy['discount_percentage'] = (Number(dataCopy['discount']) / Number(dataCopy['total_amount']) * 100)

		if (totalPayments <= Number(dataCopy.total_amount)) {
			dataCopy.shortage =
				Number(dataCopy.total_amount) -
				Number(totalPayments) -
				Number(dataCopy.entity_debtor_amount) -
				Number(dataCopy.organization_amount)
		}

		if (Number(paid) > Number(dataCopy.total_amount)) {
			dataCopy.shortage = 0
		}

		const elementBalanceMap = {};

		if (id) {
			dataCopy.products.forEach(product => {
				if (product.element_id && !product.is_prepared) {
					const key = `${product.element_id}-${product.balance_id}`;

					if (elementBalanceMap[key] === undefined) {
						elementBalanceMap[key] = Number(product.balance) || 0;
					}

					if (product.id) {
						const amount = product.product_type === 4
							? Number(product.metr || 0)
							: Number(product.roll_metr || 0);
						elementBalanceMap[key] += amount;
					}
				}
			});
		}

		dataCopy.products = dataCopy.products.map(product => {
			if (product.is_prepared) {
				return {
					...product,
					actual_balance: Number(product.balance) || 0,
				};
			}

			if (product.element_id) {
				if (elementBalanceMap[`${product.element_id}-${product.balance_id}`] === undefined) {
					elementBalanceMap[`${product.element_id}-${product.balance_id}`] = Number(product.balance) || 0;
				}

				const before = elementBalanceMap[`${product.element_id}-${product.balance_id}`];

				if (product.product_type === 4) {
					elementBalanceMap[`${product.element_id}-${product.balance_id}`] = before - Number(product.metr || 0);
				}
				if (product.product_type === 3 || product.product_type === 5) {
					elementBalanceMap[`${product.element_id}-${product.balance_id}`] = before - Number(product.roll_metr);
				}

				return {
					...product,
					actual_balance: before,
				};
			}

			return {
				...product,
				actual_balance: product.balance,
			};
		});

		const balanceMap = dataCopy.products.reduce((map, product) => {
			if (product.product_type === 4) {
				map[`${product.element_id}-${product.balance_id}`] = product.actual_balance - product.metr;
			}
			if (product.product_type === 3 || product.product_type === 5) {
				map[`${product.element_id}-${product.balance_id}`] = product.actual_balance - product.roll_metr;
			}
			return map;
		}, {});

		var productsCopy = { ...products }
		if (productsCopy.categories.length > 0) {
			productsCopy.categories = productsCopy.categories.map(category => {
				const updatedCategoryProducts = category.products.map(product => {
					const key = `${product.product_id}-${product.balance_id}`;
					const actual_balance = balanceMap[key];
					return {
						...product,
						actual_balance: actual_balance !== undefined ? actual_balance : product.balance,
					};
				});

				return {
					...category,
					products: updatedCategoryProducts,
				};
			});

			setProducts(productsCopy)
		}

		setData({
			...dataCopy,
			'change': change,
			'paid': paid,
			'entity_debtor_amount': dataCopy.entity_debtor_amount,
			'shortage': dataCopy.shortage,
		})

		saveTransferData({
			...dataCopy,
			'change': change,
			'paid': paid,
			'entity_debtor_amount': dataCopy.entity_debtor_amount,
			'shortage': dataCopy.shortage,
		})
	}

	function saveTransferData(data) {
		if (!id) {
			dispatch({
				type: 'SET_CHEQUE_DATA',
				payload: { ...data }
			})
		}
	}

	function exactAmount(index) {
		var dataCopy = { ...data }
		dataCopy.total_amount += dataCopy.discount_amount;
		var paid = 0
		for (let i = 0; i < dataCopy.payments.length; i++) {
			if (index !== i) {
				paid += Number(dataCopy.payments[i]['amount']);
			}
		}

		if (Number(dataCopy.total_amount) > Number(paid)) {
			dataCopy.payments[index]['amount'] = Math.round(Number(dataCopy.total_amount) - Number(paid))
			if (dataCopy.payments[index]['is_usd']) {
				// currentCurrency=0 (kurs hali yuklanmagan) da Infinity bo'lmasin
				dataCopy.payments[index]['amount_usd'] = currentCurrency > 0
					? Math.ceil((Number(dataCopy.total_amount) - Number(paid)) / currentCurrency)
					: 0
			}
		}
		calculateTotalAmount(dataCopy)
	}

	async function handleChange(e) {
		var dataCopy = { ...data }
		dataCopy[e.target.name] = e.target.value.replace(/[^0-9.]/g, '');

		if (e.target.name === "debt_days") {
			const result = new Date();
			result.setDate(result.getDate() + parseInt(dataCopy.debt_days ? dataCopy.debt_days : 0, 10));
			dataCopy.debt_date = result;
		}
		setData(dataCopy)
	}

	function handleChangePayment(index, e) {
		var dataCopy = { ...data }
		if (dataCopy.payments[index]['is_usd']) {
			dataCopy.payments[index]['amount_usd'] = sanitizeDecimal(e.target.value);
			dataCopy.payments[index]['amount'] = dataCopy.payments[index]['amount_usd'] * currentCurrency;
		} else {
			dataCopy.payments[index]['amount'] = sanitizeDecimal(e.target.value);
		}
		calculateTotalAmount(dataCopy)
	}

	async function toggleModalDelete(bool, item, index) {
		if (bool) {
			if (item.id) {
				setModalDelete({ ...modalDelete, product: item, show: true, note: '' })
			} else {
				deleteItem(index)
			}
		} else {
			setModalDelete({ show: false })
		}
	}

	async function deleteItem(payloadIndex) {
		var dataCopy = { ...data };
		var productsCopy = [...dataCopy.products];
		var index;
		if (payloadIndex >= 0) {
			index = payloadIndex;
		} else {
			index = dataCopy.products.findIndex(item => item.id === modalDelete.product.id);

			if (modalDelete.product.id) {
				const response = await DELETE(`/cheques-delete-product`, { 'cheque_id': id, 'id': modalDelete.product.id, note: modalDelete.note }, { loader: true })
				if (!httpOk(response)) {
					return;
				}
			}

		}

		productsCopy.splice(index, 1);

		dataCopy.products = productsCopy;

		setModalDelete({ show: false })
		if (payloadIndex >= 0) {
			calculateTotalAmount(dataCopy);
		} else {
			getProducts(dataCopy)
		}
	}

	function addProductType2(e) {
		e.preventDefault();

		var item = { ...modalQuantity }
		var dataCopy = { ...data }

		item.status = 0;
		dataCopy.products.push(item)

		setModalQuantity({ show: false })
		calculateTotalAmount(dataCopy)
	}

	/* CHIZMA MODULI TARIFDA BORMI (`full`, yoki POS ga alohida ochilgan).
	   Yo'q bo'lsa: Chizish tugmasi ham, avtomat ochilish ham, «chizmasiz
	   sotilmasin» to'sig'i ham ISHLAMAYDI — tenant eski tartibda ishlayveradi
	   (kenglik katalogdan). Tarif tushirilganda kassa qulflanib qolmasligi
	   uchun ataylab shunday. */
	const canDraw = checkPermission('sec.accessory_drawing')

	/* ZAKAZ MUDDATINI REJALASHTIRISH (full tarif).
	   Tarifda bo'lmasa hech narsa o'zgarmaydi — sotuvchi eski tartibda sana qo'yadi. */
	const canPlanDelivery = checkPermission('sec.delivery_planning')

	/* Sana tavsiyasi — NAVBATga qarab. Qoida korxonaning o'z tarixidan o'lchangan:
	   navbatda 0-10 ta -> shu kun (95.2% vaqtida), 11-25 -> +1 kun (89.1%),
	   26-50 -> +2 kun (78.8%). Tafsiloti: DeliveryPlanningController. */
	/* NAVBAT MATNI — sana katakchasining ichida (placeholder) turadi.
	   «Навбат: 17 · 1.87 иш куни» — zakaz SONI emas, ish HAJMI: 200 m
	   cherepitsa bilan 3 dona aksessuar bir xil sanalmasligi uchun.
	   Quvvat sozlanmagan tenantda kunlik ish ko'rsatilmaydi (has_capacity). */
	/* Sanani BELGILAGAN bo'lim nomi. Sexlar bir vaqtda ishlaydi, shuning uchun
	   sana eng band bo'lim bo'yicha chiqadi — sotuvchi qaysi sex kutayotganini
	   ko'rib tursin (ilgari hamma bo'lim qo'shilib bitta raqam chiqardi). */
	const DEPT_NAMES = { 1: 'Продукт', 3: 'Аксессуар', 4: 'Профнастил', 5: 'Туникофон' }

	const queueText = (canPlanDelivery && deliverySuggestion)
		? (deliverySuggestion.has_capacity && deliverySuggestion.slowest_type
			? `${DEPT_NAMES[deliverySuggestion.slowest_type] || t('queue')}: `
				+ `${deliverySuggestion.dept_days} ${t('work_days')}`
			: `${t('queue')}: ${deliverySuggestion.queue}`
				+ (deliverySuggestion.has_capacity
					? ` · ${deliverySuggestion.queue_work_days} ${t('work_days')}`
					: ''))
		: ''

	async function loadDeliverySuggestion() {
		if (!canPlanDelivery) return

		/* Savatdagi qatorlar. `product_type` va `width` ham yuboriladi:
		   ⚠️ TUNIKOFON (tur 5) KV.METRDA hisoblanadi — yuza = metr × eni.
		      Uzunlik metri bilan sanalsa quvvat 3 barobar xato bo'ladi
		      (korxona egasi tuzatgan: «bazida 250 kv, bazida 350-400 kv»). */
		const items = (data.products || [])
			.filter(p => p.show !== false)
			.map(p => ({
				balance_id: p.balance_id,
				product_id: p.product_id,
				product_type: p.product_type,
				quantity: p.quantity,
				metr: p.metr,
				draw_width: p.draw_width,
				width: p.width,
			}))

		const response = await POST('/delivery-suggestion', { items }, { loader: false })
		if (httpOk(response)) setDeliverySuggestion(response.data)
	}

	/** Tavsiya etilgan sanani maydonga qo'yadi */
	function applyDeliverySuggestion() {
		if (!deliverySuggestion?.suggested_date) return
		setData({
			...data,
			'delivery_date': formatDate(new Date(deliverySuggestion.suggested_date), 'yyyy-MM-dd HH:mm'),
			'delivery_override_reason': null,
		})
	}

	/* CHIZMA USTUNI KO'RINSINMI (2026-08-13, korxona egasining talabi).

	   Muammo: Start tarifda chizma moduli yo'q, lekin «Чизма» ustuni
	   baribir turardi va har qatorda «—» chiqardi. Sotuvchi uchun bu
	   ishlamaydigan tugma — dastur buzuq ko'rinadi va ustun bekorga
	   joy egallaydi (kassa jadvali allaqachon 12 ustunli).

	   ⚠️ Lekin ustunni SHUNCHAKI `canDraw` bilan yopib bo'lmaydi: tarif
	      TUSHIRILGAN tenantda eski cheklarda chizma bor va u ko'rinmay
	      qolardi (pastdagi izohda ataylab shunday qilingan edi).
	      Shu sabab shart ikkitadan: ruxsat BOR, YOKI qatorlarda
	      chizma BOR. Start tenantда ikkalasi ham yo'q → ustun yo'q. */
	const hasAnyDrawing = (data.products || []).some(p => p && p.draw_png)
	const showDrawCol = canDraw || hasAnyDrawing

	/* ═══ NARX BAZASI: rulon SOTUV narximi yoki TANNARXIMI? ═══
	   Ruxsati BOR tenant  → narx = rulon SOTUV narxi + ustama (yangi model).
	   Ruxsati YO'Q tenant → narx = rulon TANNARXI  + ustama (ESKI, o'zgarmagan).

	   ⚠️ NEGA `canDraw` EMAS, ALOHIDA RUXSAT:
	   Chizma — tarif imkoniyati, narx esa biznes qarori. Ikkisini bitta
	   bayroqqa bog'lasak, tenant `full` dan `pro` ga tushganda butun
	   prays-listi jimgina siljirdi (`apply-drawing-tariff.sh:20-21` qoidasi).

	   ⚠️ Bu bayroqsiz yangi kod chiqarilsa, ruxsati yo'q 11 ta tenantda narx
	      o'z-o'zidan o'zgarardi — o'lchangan: aksessuar +6.9…+12.8%,
	      tunikofon −9.9…−15.4%. Ular bundan xabarsiz. */
	const useSalePriceBase = checkPermission('sec.price_base_sale')

	/* ═══ TUNIKOFON: DOSKA rejimimi? ═══
	   `products.calc_mode`: 1 = doska, 2 (yoki bo'sh) = karniz.
	     DOSKA  — chizma doskaning UZUNLIGINI beradi (Ҳажми), kenglik esa
	              kesilgan listni 1/2/3/4 ga bo'lishdan chiqadi.
	     KARNIZ — aksessuardagidek: chizma KENGLIKNI (sarf) beradi.
	   ⚠️ Nomdan aniqlanmaydi — «Karniz» ikkala turda ham bor va boshqa
	      tenantda nomlar butunlay boshqacha (2026-08-11). */
	const isDoska = p => Number(p?.product_type) === 5 && Number(p?.calc_mode ?? 2) === 1
	/* Chizma oynasida tanlangan rulon. Ikki joydan yoziladi — oynadagi
	   ro'yxatdan va «⋯» bilan ochiladigan partiya jadvalidan. Bitta joyda
	   turgani uchun ikkalasi bir-biridan uzoqlashib ketmaydi. */
	const [drawRoll, setDrawRoll] = useState(null)

	/* ═══ USTAMA: BO'LAK SONIGA QARAB ═══
	   Muammo: `markup` RULON metriga yoziladi va bo'laklarga BO'LINADI —
	   10 000 qo'yilsa 1b ga 10 000, 5b ga atigi 2 000 tushadi. Amalda esa
	   25 sm lik bo'lakka 4 000 dan olinadi (rulon metriga 20 000).
	   Standartda buni har mahsulotga alohida raqam qo'yib hal qilishgan;
	   nostandartda bitta mahsulot — razvyortka har safar boshqa.

	   Yechim: mahsulotga jadval — {"1":10000,"2":8000,...}, qiymat
	   1 METR MAHSULOTGA. Bu yerda u eski formulaga mos «rulon metriga»
	   ko'rinishiga qaytariladi, shunda quyi oqimdagi hamma hisob
	   (roll_metr · jami · backend) tegilmasdan qoladi:
	       ustama_rulon = ustama_bo'lak × rulon_eni ÷ rasxod
	   Jadval bo'sh bo'lsa — eski `markup` ishlaydi, hech narsa buzilmaydi. */
	function effMarkup(product, prodLength, effWidth) {
		if (!(prodLength > 0) || !(effWidth > 0)) return Number(product['markup'] ?? 0)
		/* Bo'lak soni — razvyortka rulon eniga necha marta sig'ishi.
		   ⚠️ Chegara 1e-9 EMAS, 0.01: rasxod qo'lda «416.7» deb yozilsa
		      1250/416.7 = 2.99976 bo'lib, 3b o'rniga 2b hisoblanardi va
		      xizmat haqi noto'g'ri qatordan olinardi (2026-08-09). */
		const fits = Math.max(1, Math.floor(prodLength / effWidth + 0.01))
		const tier = tierMarkup(product['markup_tiers'], fits)
		if (tier == null) return Number(product['markup'] ?? 0)
		return tier * prodLength / effWidth
	}

	/* RULON MAYDONLARI — bitta joyda. Jadvaldagi rulon select'i ham,
	   chizma oynasidagi rulon select'i ham shuni chaqiradi, aks holda
	   ikkalasi vaqt o'tib bir-biridan uzoqlashib ketardi. */
	function applyRoll(product, value) {
		if (!value) return;
		product['element_balance_id'] = value?.balance_id;
		product['element_name'] = value.name;
		product['element_id'] = value.product_id;
		product['roll_quantity'] = value.quantity;
		product['balance'] = value.balance;
		product['created_at'] = value.created_at;
		product['sale_price'] = value.sale_price;
		/* ⚠️ NARX BAZASI UCHUN ALOHIDA NOM.
		   `sale_price` ikki xil ma'noda ishlatiladi: YANGI qatorda — rulon
		   narxi (shu yerda), YUKLANGAN chekda esa — QATORNING o'z narxi
		   (`show()`: chp.*). Narx hisobida `sale_price` ni ishlatgani uchun
		   eski chek ochilganda narx qatorning o'z narxidan qayta hisoblanib
		   buzilardi. Endi hisob FAQAT `roll_sale_price` ga tayanadi. */
		product['roll_sale_price'] = value.sale_price;
		product['price'] = value.price;
		product['wms_id'] = value.wms_id;
		product['balance_id'] = value.balance_id;
		product['element_category_name'] = value.category_name;
		// RULON RANGI — chizma oynasidagi 3D shu rangda ko'rsatiladi
		product['element_ral'] = value.ral_code;
		product['is_new'] = value.balance === value.quantity;
	}

	function handleChangeProductSelect(index, key, value) {
		var dataCopy = structuredClone(data)
		var product = dataCopy.products[index];

		// T4: yangi mahsulot tanlanganda qo'lda kiritilgan narx bayrog'i tozalanadi (yangi mahsulot — yangi narx)
		product['is_price_manual'] = false;

		// if (activeTab !== 3 && value.balance_id && key !== 'element_id' && !modalSelectProduct.is_prepared) {
		// 	setModalSelectProduct({
		// 		show: true,
		// 		index: index,
		// 		key: 'product_id',
		// 		is_prepared: true,
		// 		product_id: value.product_id
		// 	})
		// 	return;
		// }

		// Ochilmagan (Янги) rulondan sotib bo'lmaydi — uni sex/omborchi ochishi kerak.
		// ⚠️ LEKIN qoldig'i 0 bo'lgan partiya ISTISNO (2026-07-28, qarzga sotish):
		// ayiradigan narsa yo'q, butun miqdor «Rulon qarzi» (pending_orders) ga tushadi —
		// backend ham shunday ishlaydi (deductBalanceClamped: tanlangan partiyadan 0
		// ayiriladi, `is_opened` sharti faqat BOSHQA partiyalar uchun, ChequeController:2721).
		// Bu shart bo'lmasa hamma partiyasi tugagan va ochilmagan holda qolgan rulon
		// («7024/045 MOK TMZ» kabi) sotuvda ko'rinadi-yu, tanlab bo'lmaydi.
		const rollNoStock = isBackorderRow(value)
		if (!value.is_opened && !rollNoStock && modalSelectProduct.show && modalSelectProduct.key === 'element_id') {
			toast.error(t('roll_not_open'));
			return;
		}

		if (product.quantity) {
			product.quantity = '';
			product.element_quantity = "";
			product.metr = "";
			product.roll_metr = "";
			// product.sale_price = 0;
		}

		if (key === 'element_id') {
			applyRoll(product, value);
		} else if (activeTab === 3) {
			dataCopy.products[index] = {
				...dataCopy.products[index],
				...value,
				product_name: value.name,
				quantity: '',
			};
		} else if (activeTab === 1) {
			product['product_id'] = value.product_id;
			product['product_name'] = value.name;
			product['percentage'] = value.percentage;
			product['is_prepared'] = false;
			/* CHEREPITSA (2026-08-28): Boshi/Shag paneli FAQAT cherepitsa
			   (is_tile) mahsulotda chiqadi (egasi: «boshqa shakllarda chiqib
			   qolmasin»). Boshqa shakl tanlansa is_tile=false -> panel yo'qoladi,
			   qiymatlar tozalanadi (chekka eskirgan boshi/shag ilashmasin). */
			product['is_tile'] = !!value.is_tile;
			if (value.is_tile) {
				// Cherepitsa — bo'sh maydonlar UMUMIYdan to'ladi
				if ((product['tile_start_sm'] ?? '') === '' && tileDefault.start !== '') product['tile_start_sm'] = tileDefault.start
				if ((product['tile_step_sm'] ?? '') === '' && tileDefault.step !== '') product['tile_step_sm'] = tileDefault.step
			} else {
				// Cherepitsa EMAS — eskirgan boshi/shag chekka chiqib qolmasin
				product['tile_start_sm'] = null
				product['tile_step_sm'] = null
			}
			// product['balance'] = "";
			// product['balance_id'] = "";
		} else {
			product['product_id'] = value.product_id;
			product['product_name'] = value.name;
			product['width'] = value.width;
			product['length'] = value.length;
			product['markup'] = value.markup;
			product['is_prepared'] = false;
			product['needs_drawing'] = !!value.needs_drawing;
			// tunikofon hisoblash tartibi (1 = doska, 2 = karniz)
			product['calc_mode'] = value.calc_mode ?? null;
			product['markup_tiers'] = value.markup_tiers || null;
			/* ═══ NOM TANLANDI — IKKI XIL YO'L ═══
			   STANDART (needs_drawing = false):
			     shablon chizmasi biriktiriladi, lekin `draw_width` YOZILMAYDI —
			     narx katalogdagi «Kenglik» dan chiqadi («3b» = 1250÷3 = 416.7).
			     Chizma faqat ustaga topshiriq va chekdagi rasm uchun.
			     ⚠️ Ilgari `draw_width` ham yozilardi — shablon chizmasi 380 mm
			        bo'lsa standart mahsulot narxi jimgina 380 ga tushib ketardi.
			   NOSTANDART (needs_drawing = true):
			     chizma oynasi O'ZI ochiladi (pastda), narx CHIZMADAN. */
			const tpl = accTemplates.find(x => Number(x.product_id) === Number(value.product_id))
			if (tpl) {
				product['draw_json'] = tpl.draw_json
				/* ⚠️ TUNIKOFONDA (tur 5) `draw_width` HECH QACHON yozilmaydi —
				   u yerda chizma UZUNLIKNI (Ҳажми) beradi, kenglikka tegmaydi.
				   Aksessuarda esa nostandartda kenglik chizmadan keladi. */
				product['draw_width'] = (value.product_type !== 5 && value.needs_drawing)
					? tpl.draw_width : null
				/* Tunikofon standart shakli: shablon ёйилмаси = doska uzunligi,
				   ya'ni Ҳажми ni o'zi to'ldirib beradi — usta qayta yozmaydi. */
				if (isDoska(value) && tpl.draw_json?.blank > 0) {
					product['element_quantity'] = tpl.draw_json.blank / 1000
				}
				product['draw_png'] = tpl.draw_png
			} else {
				product['draw_json'] = null
				product['draw_width'] = null
				product['draw_png'] = null
			}
			// product['balance'] = "";
			// product['balance_id'] = "";
		}

		if (activeTab !== 3 && value.balance_id && key !== 'element_id') {
			// product = structuredClone(value);

			product['wms_id'] = value.wms_id;
			product['balance'] = value.balance;
			product['balance_id'] = value.balance_id;
			product['element_balance_id'] = value.balance_id;
			product['is_prepared'] = true;
			product['sale_price'] = value.sale_price;
			// product['accessory_sale_price'] = value.sale_price;
			product['accessory_sale_price_metr'] = value.sale_price;
			product['element_id'] = value.element_id;
			product['element_name'] = value.element_name;
			product['created_at'] = value.created_at;

			setTimeout(() => {
				if (inputRefs.current[index] && inputRefs.current[index]) {
					inputRefs.current[index].focus();
				}
			}, 10);
		}

		if (modalSelectProduct.show) {
			setModalSelectProduct({ show: false })
		}
		calculateTotalAmount(dataCopy)

		// Rulon (partiya) tanlangach fokusni "Хажми" (element_quantity) input'iga ko'chiramiz —
		// foydalanuvchi darrov o'lchamni yozsin, partiya select'iga qaytib qolmasin.
		if (key === 'element_id') {
			setTimeout(() => {
				if (sizeRefs.current[index]) sizeRefs.current[index].focus();
			}, 50);
		}

		/* NOSTANDART AKSESSUAR TANLANDI — chizma oynasi O'ZI ochiladi.
		   Rulon, hajm va soni ham o'sha oynada yoziladi, chunki nostandartda
		   ular chizmasiz ma'nosiz: kenglik chizmadan chiqadi. */
		if (canDraw && key === 'product_id' && value && value.needs_drawing) {
			setDrawRoll(null)
			setTimeout(() => setDrawModal({ show: true, index }), 120);
		}
	}

	function handleChangeCategoriesSelect(index, option) {
		if (option.value === 'preparation') {
			var dataCopy = { ...data }
			var product = dataCopy.products[index];

			product['balance'] = product.product_balance;

			return;
		}
		setModalSelectProduct({ show: true, index: index, key: 'element_id', children: option.products })
	}

	// Rulon-select — klaviatura: Enter bosilganda partiya (rulonlar) oynasini ochadi.
	// onKeyDownCapture (o'rash div'ida) react-select'dan OLDIN (capture fazasi) ishlaydi —
	// shuning uchun Enter'ni ishonchli ushlaydi. Fokusdagi kategoriya react-select ichki
	// holatidan (ref) olinadi; topilmasa — barcha rulonlar ko'rsatiladi (fallback).
	function handleRollCategoryKeyDown(e, index) {
		if (e.key !== 'Enter') return;
		e.preventDefault();
		e.stopPropagation();
		const focused = rollSelectRefs.current[index]?.state?.focusedOption;
		const children = (focused && Array.isArray(focused.products)) ? focused.products : products.rolls;
		setModalSelectProduct({ show: true, index: index, key: 'element_id', children: children });
	}

	// T12: bir nechta nuqtali son ("1.2.3" -> NaN) kiritishga yo'l qo'ymaydi — faqat birinchi nuqta qoladi
	function sanitizeDecimal(raw) {
		let v = String(raw ?? '').replace(/[^\d.]/g, '');
		const dot = v.indexOf('.');
		if (dot !== -1) v = v.slice(0, dot + 1) + v.slice(dot + 1).replace(/\./g, '');
		return v;
	}

	/* CHEREPITSA maydoni uchun tozalash: sanitizeDecimal + NUMERIC(6,1) cheklovi
	   (5 xona butun + 1 xona kasr, yolg'iz "." yo'q — PG invalid input syntax
	   butun chekni saqlatmay qo'yardi). Qator inputi va UMUMIY panel bir xil
	   qoidada bo'lishi SHART — ajralsa umumiydan kelgan qiymat qatorda
	   o'tmaydigan bo'lib qoladi. */
	function sanitizeTileSm(raw) {
		var v = sanitizeDecimal(raw)
		var m = v.match(/^(\d{0,5})(\.\d?)?/)
		v = m ? (m[1] + (m[2] ?? '')) : ''
		return v === '.' ? '' : v
	}

	/* CHEREPITSA paneli shu qatorda ko'rinsinmi — FAQAT cherepitsa (is_tile)
	   mahsulotда (2026-08-28, egasi: «faqat cherepitsa tanlanganda chiqsin,
	   boshqa shakllarda chiqib qolmasin»). Ilgari «+» tugma bilan har qanday
	   profnastil qatorida ochilardi — u OLIB TASHLANDI, chunki egasi boshqa
	   shakllarda panel/tugma ko'rinishini istamadi. Mahsulotni cherepitsa deb
	   belgilash — Mahsulot kartasidagi «Cherepitsa» galochkasi (products.is_tile).
	   YAGONA manba: qator renderi, umumiy panel va applyTileDefault shundan. */
	function isTileOpen(item) {
		if (!item || item.is_prepared || item.product_type !== 4 || !item.product_id) return false
		return !!item.is_tile
	}

	/* UMUMIY boshi/shag o'zgardi: qiymat OCHIQ panelli BARCHA qatorlarga
	   yoziladi (qatorda keyin qo'lda o'zgartirish mumkin — u faqat o'sha
	   qatorga ta'sir qiladi; umumiy QAYTA o'zgartirilsa yana hammasiga yozilib,
	   qatordagi qo'lda kiritilganni ham bosib ketadi — bu ongli qaror:
	   «umumiy» so'zi shuni anglatadi, oldindan aytib bo'lmaydigan qisman
	   qo'llashdan ko'ra tushunarliroq). Yangi cherepitsa qatorlari (Enter-nusxa /
	   mahsulot tanlash) umumiydan boshlab keladi. Panel is_tile'ga bog'liq. */
	function applyTileDefault(field, raw) {
		var value = sanitizeTileSm(raw)
		setTileDefault({ ...tileDefault, [field]: value })
		var key = field === 'start' ? 'tile_start_sm' : 'tile_step_sm'
		var dataCopy = structuredClone(data)
		var touched = false
		for (var i = 0; i < (dataCopy.products || []).length; i++) {
			var p = dataCopy.products[i]
			if (isTileOpen(p)) {
				p[key] = value === '' ? null : value
				touched = true
			}
		}
		if (touched) setData(dataCopy)
	}

	function handleChangeProduct(index, e) {
		var dataCopy = structuredClone(data)
		var product = dataCopy.products[index];
		var value = sanitizeDecimal(e.target.value);

		/* CHEREPITSA maydonlari (tekshiruv topilmasi, 2026-08-27):
		   1) NUMERIC(6,1) ga sig'sin — 5 xona butun + 1 xona kasr; yolg'iz "."
		      yuborilmasin (PG: invalid input syntax — butun chek saqlanmay qolardi;
		      backend tileValue() ham himoya qiladi, bu yerda esa kasr KESILMAY
		      turib chekka chiqishi bilan bazadagi yaxlitlangani ajralib qolmasin);
		   Panel is_tile'ga bog'langani uchun yozish paytida yopilib qolmaydi. */
		if (e.target.name === 'tile_start_sm' || e.target.name === 'tile_step_sm') {
			value = sanitizeTileSm(value)
		}

		if (e.target.name === 'accessory_sale_price_metr') {
			product[e.target.name] = e.target.value.replace(/\D/g, '');
		} else {
			product[e.target.name] = value;
		}

		/* T4: kassir narxni QO'LDA kiritsa, uni belgilaymiz — miqdor o'zgarganda
		   avto-hisob uni o'chirmasin.
		   ⚠️ `accessory_sale_price_metr` ham SHU RO'YXATDA: u ham qo'lda kiritiladigan
		      narx maydoni (metrga narx), lekin belgilanmagani uchun kassir narx yozib,
		      keyin Сони ni o'zgartirsa yozgani jimgina katalog narxiga qaytardi. */
		if (e.target.name === 'accessory_sale_price' || e.target.name === 'accessory_sale_price_metr') {
			product['is_price_manual'] = true;
		}

		// Подсчет метра
		if (product['is_prepared']) {

			if (product['product_type'] === 4) {
				product['total_price'] = Number(product['quantity']) * Number(product['sale_price']);
				product['metr'] = Number(product['quantity']);
			} else if (product['product_type'] === 3 || product['product_type'] === 5) {
				product['accessory_total_price'] = Number(product['quantity']) * Number(product['accessory_sale_price_metr']);
				product['sale_price'] = product['accessory_sale_price_metr'];
				product['total_price'] = product['accessory_total_price'];
			}
		} else {
			if (e.target.name === 'quantity' || e.target.name === 'element_quantity') {
				product['metr'] = (product['quantity'] ?? 0) * (product['element_quantity'] ?? 0);

				// Добавлять к метру процент
				if (product['percentage']) {
					product['metr'] =
						((product['element_quantity'] * product['quantity'])) +
						(product['element_quantity'] * product['quantity']) *
						(product['percentage'] / 100);
				}
			}
			if (product['product_type'] === 3 || product['product_type'] === 5) {
				// length=0/undefined da nolga bo'linish (Infinity/NaN narx) bo'lmasin
				const prodLength = Number(product['length'])
				// AKSESSUAR CHIZMASI: mijoz oldida chizilgan bo'lsa RASXOD eni
				// (draw_width) katalogdagi `products.width` dan ustun turadi.
				// Backend ham aynan shu tartibda hisoblaydi (ChequeController).
				const effWidth = Number(product['draw_width'] ?? product['width'] ?? 0)
				product['roll_metr'] = prodLength > 0 ? product['metr'] / prodLength * effWidth : 0;
				/* ⚠️ TUNIKOFON kv.metri — `roll_metr × rulon eni`, ya'ni AYNAN
				   `metr × effWidth`. Foydalanuvchi hisobi (2026-08-11):
				     ёйилма 0.88 × 40 dona = 35.2 m doska
				     2b → rulonga 2 ta sig'adi → 35.2 ÷ 2 = 17.6 rulon metr
				     kv = 17.6 × 1.25 = 22
				   ⚠️ Bir kun «ko'rinadigan kenglik» (yuza) alohida hisoblangan edi —
				   NOTO'G'RI bo'lib chiqdi, foydalanuvchi qaytardi. Kv rulon
				   yuzasidan hisoblanadi, ko'rinadigan yuzadan emas. */
				if (product['product_type'] === 5) {
					product['kv_metr'] = (product['roll_metr'] ?? 0) * (product['length'] ?? 0);
				}
				if (e.target.name !== 'accessory_sale_price' && !product['is_price_manual']) {
					/* ═══ NARX BAZASI: rulonning SOTUV narxi ═══
					   Ilgari TANNARX (prixod) olinardi va marja ustama ichiga
					   qo'lda kiritilardi. Lekin marja har rulonda har xil —
					   108 rulonda −11% dan +50% gacha, 79 xil qiymat. Ustama esa
					   MAHSULOTGA biriktirilgan, rulonga emas: bitta nostandart
					   mahsulot ikki xil rulondan kesilsa marja to'g'ri chiqmasdi.
					   Sotuv narxi bazasida marja har rulonda o'zi to'g'ri bo'ladi
					   va kurs/prixod o'zgarganda narx O'ZI ergashadi (2026-08-09).

					   ⚠️ TUNIKOFON (tur 5) ham 2026-08-11 dan SHU BAZAGA o'tdi.
					   Foydalanuvchining haqiqiy qoidasi: «kv.metrni profnastilning
					   SOTUV narxida sotamiz, foyda 1.25 koeffitsientidan chiqadi»
					   (rulon 52 000 keldi → 55 000/kv.m → 1 metr = 68 750 → foyda
					   16 750). Ilgari baza TANNARX edi va farqni sotuvchi qo'lda
					   yozib turardi. Bazadagi dalil: 2464 ta tunikofon qatoridan
					   faqat 27 tasi katalog ustamasini (15 000) ishlatgan, 1240
					   tasi aynan rulon farqi (~6 600) bilan ketgan — ya'ni amalda
					   allaqachon SOTUV narxi qoidasi ishlayotgan edi.
					   Shu bilan tur 3 va tur 5 uchun baza BIR XIL bo'ldi. */
					/* ⚠️ BAZA `roll_sale_price` DAN OLINADI, `sale_price` DAN EMAS.
					   Yuklangan chekda `sale_price` — QATORNING o'z narxi (show(): chp.*),
					   rulonniki emas. Ilgari shu ikkisi aralashib, eski chek ochilganda
					   narx qayta hisoblanib buzilardi.

					   ESKI BAZAGA QAYTISH ikki holatda:
					     1) tenantda `sec.price_base_sale` ruxsati yo'q — u eski
					        modelda ishlashda davom etadi (narxi siljimaydi);
					     2) rulonning katalogda sotuv narxi yozilmagan (lokal bazada
					        2 ta shunday rulon bor) — 0 so'm yozib tannarxdan past
					        sotgandan ko'ra eski formula xavfsizroq. */
					const rollSaleBase = Number(product['roll_sale_price'] ?? 0)
					const useNewBase = useSalePriceBase && rollSaleBase > 0
					const priceBase = useNewBase ? rollSaleBase : Number(product['price'] ?? 0)

					if (product['product_type'] === 5 && useNewBase) {
						/* ═══ TUNIKOFON NARXI — KV.METRDA, KENGLIKKA BOG'LIQ EMAS ═══
						   Ustama kesilgan LISTNING bir metriga qo'shiladi, keyin
						   hammasi kv.metrga aylantiriladi:

						     кв.м нархи = (рулон сотув нархи + устама) ÷ рулон эни

						   Misol (2026-08-11): 57 000 + 20 000 = 77 000; ÷1.25 = 61 600.
						   Doska ham, karniz ham AYNAN bir xil narxda — foydalanuvchi:
						   «карниз да ҳам доскада ҳам ҳаммаси кв бўлади, 57 000 сотув
						    нархи бўлса автомат нарх 60 000 атрофида чиқиши керак».

						   ⚠️ Ilgari ustama DOSKA KENGLIGIGA bo'linardi (20 000 ÷ 0.625
						      = 32 000) va narx 77 600 gacha ko'tarilib ketardi. Tor
						      karnizda esa 125 600 chiqardi — ikki barobar ortiqcha.
						   ⚠️ `effMarkup()` BU YERDA ISHLATILMAYDI: u ustamani bo'lak
						      soniga ko'paytiradi (aksessuar mantig'i) — boshqa birlik. */
						product['accessory_sale_price'] = prodLength > 0
							? Math.round((priceBase + Number(product['markup'] ?? 0)) / prodLength)
							: 0
					} else {
						/* ESKI MODEL (ruxsatsiz tenant) ham, aksessuar ham shu yerda.
						   `effMarkup()` ustama jadvali bo'lmasa oddiy `markup` ga
						   qaytadi (:648), shuning uchun eski xulq buzilmaydi —
						   jadval butun bazada faqat 1 ta mahsulotda sozlangan. */
						product['accessory_sale_price'] = Math.round(priceBase + Number(effMarkup(product, prodLength, effWidth)))
					}
				}
				if (e.target.name !== 'accessory_total_price') {
					product['accessory_total_price'] = Math.round(product['accessory_sale_price'] * (product['product_type'] === 5 ? product['kv_metr'] : Number(product['roll_metr'])))
					// product['accessory_total_price'] = Math.round(product['accessory_sale_price'] * Number(product['roll_metr']))
				}
				if (e.target.name === 'accessory_sale_price_metr') {
					product['accessory_total_price'] = Math.round(product['accessory_sale_price_metr'] * Number(product['metr']))
				}
				if (e.target.name !== 'accessory_sale_price_metr') {
					const metrNum = Number(product['metr'])
					product['accessory_sale_price_metr'] = metrNum > 0 ? Math.round(Number(product['accessory_total_price']) / metrNum) : 0
				}
			}
		}
		// BACKORDER: qoldiqdan oshiq miqdor kiritishga RUXSAT beriladi (buyurtma).
		// Ilgari bu yerda return bilan bloklanardi (qoldiqdan oshirib bo'lmasdi). Endi bloklamaymiz —
		// ombor yetmasa, yetishmagan qism backendda "kutilayotgan buyurtma" (pending_orders) bo'ladi.
		// Qoldiq (actual_balance) manfiyga tushsa qizil bo'lib ko'rinadi — bu ogohlantirish.

		dataCopy.products[index] = product;
		calculateTotalAmount(dataCopy)
	}

	function onKeyPress(e, index) {
		var products = getDataProducts().filter(item => item.show);
		var currentProduct = data.products[index];

		var filteredIndex = products.findIndex(p => {
			if (currentProduct.id) {
				return p.id === currentProduct.id;
			} else {
				return p.unique_id === currentProduct.unique_id;
			}
		});

		if ((e.key === 'Tab' || e.key === 'Enter') && filteredIndex === products.length - 1) {
			/* ⚠️ AKSESSUAR PROFNASTILDAN BOSHQACHA (2026-08-13, foydalanuvchi talabi).

			   PROFNASTIL (tab 1): bitta ruloniga bir necha xil uzunlik kesiladi.
			   Shuning uchun yangi qator joriy qatorning NUSXASI bo'ladi (o'sha
			   mahsulot, o'sha rulon) va fokus HAJM maydoniga tushadi — sotuvchi
			   faqat yangi o'lchamni yozadi. Bu to'g'ri xulq, tegilmadi.

			   AKSESSUAR (tab 2): har qator ODATDA BOSHQA mahsulot (Tarnov 4b,
			   Kanki 4b, Doska…). Nusxa olinsa sotuvchi avval nomni o'chirib,
			   keyin yangisini tanlashi kerak edi. Endi qator BO'SH yaratiladi
			   va fokus NOM maydoniga tushadi.

			   TUNUKAFON (tab 4) allaqachon bo'sh qator oladi — shart unga
			   tegmaydi. */
			const isProf = activeTab === 1
			addToList(1, isProf ? data.products[index] : {}, activeTab === 2 ? 'name' : 'size');
		}
	}

	/* @param focusOn — yangi qatorda fokus qayerga tushsin:
	     'size' (sukut) → HAJM maydoni (profnastil: o'sha rulondan yana o'lcham)
	     'name'         → MAHSULOT NOMI selekti (aksessuar: boshqa mahsulot) */
	function addToList(length = 1, item = {}, focusOn = 'size') {
		var dataCopy = structuredClone(data)
		var productType = 1;
		if (activeTab === 1) {
			productType = 4;
		} else if (activeTab === 2) {
			productType = 3;
		} else if (activeTab === 4) {
			productType = 5;
		}
		for (let i = 0; i < length; i++) {
			dataCopy.products.push({
				...item,
				'quantity': '',
				'element_width': '',
				'element_quantity': '',
				'total_price': '',
				'metr': '',
				'id': '',
				/* CHEREPITSA: qatorning O'Z qiymatlari nusxaga o'tmaydi (meros
				   qolsa mahsulot almashtirilgan qatorda sexga begona press
				   ko'rsatmasi chiqib ketardi) — lekin cherepitsa (is_tile) qatorining
				   nusxasi UMUMIY qiymatdan boshlab keladi (egasi: «umumiy qilaylik,
				   o'zida ham o'zgartirish imkoni qolsin»). Panel is_tile'ga bog'liq. */
				'tile_start_sm': (isTileOpen(item) && tileDefault.start !== '') ? tileDefault.start : null,
				'tile_step_sm': (isTileOpen(item) && tileDefault.step !== '') ? tileDefault.step : null,
				'product_type': productType,
				'unique_id': Date.now(),
			})
		}

		// setIsDirty(true)
		calculateTotalAmount(dataCopy)

		setTimeout(() => {
			const last = dataCopy.products.length - 1
			/* react-select ham `.focus()` ni qo'llab-quvvatlaydi. `openMenuOnFocus`
			   yoqilgani uchun ro'yxat o'zi ochiladi — sotuvchi darrov nom yozadi.
			   Ref topilmasa eski xulqqa qaytamiz, fokus umuman yo'qolmasin. */
			const target = focusOn === 'name'
				? (productSelectRefs.current[last] || refs.current[last])
				: refs.current[last]
			target?.focus()
		}, 150);
	}

	// «Tayyor ombordan» — yangi qator qo'shib, o'sha qator uchun tayyor mahsulotlar modalini ochamiz.
	// (Eski chalkash ⋮ 3-nuqta o'rniga aniq tugma.)
	/* ═══════════ AKSESSUAR CHIZMASI ═══════════
	   Rulon AVVAL tanlanadi — chizma rulon eni bilan chegaralanadi.
	   Saqlangach `draw_width` (RASXOD, metrda) qatorga yoziladi va
	   narx/rulon-metr o'sha zahoti qayta hisoblanadi. */
	function openDrawing(index) {
		const p = data.products[index]
		// Nostandartda rulon CHIZMA OYNASINING O'ZIDA tanlanadi — to'sib qo'ymaymiz
		if (!p?.element_id && !p?.needs_drawing) {
			toast.error(t('select_roll_first'))
			return
		}
		setDrawRoll(null)
		setDrawModal({ show: true, index })
	}

	function onDrawingSaved(payload) {
		const dataCopy = { ...data }
		const p = dataCopy.products[drawModal.index]
		if (p) {
			// Chizma oynasida rulon/hajm/soni tanlangan bo'lsa — qatorga ko'chiramiz.
			// ⚠️ `p` `data` ichidagi AYNAN o'sha obyekt (yuqorida sayoz nusxa) —
			//    o'zgartirish keyingi handleChangeProduct ga ham ko'rinadi.
			if (payload.roll) applyRoll(p, payload.roll)
			if (payload.element_quantity != null) p.element_quantity = payload.element_quantity
			if (payload.quantity != null) p.quantity = payload.quantity
			p.draw_json = payload.draw_json
			p.draw_png = payload.draw_png

			if (isDoska(p)) {
				/* ═══ TUNIKOFON — CHIZMA «ҲАЖМИ» NI BERADI ═══
				   Foydalanuvchi tushuntirishi (2026-08-11):
				     «rulon eni 1250. Chizma bo'yicha 0.88 m uzunlikda LIST kesamiz
				      (butun 1250 enida), keyin uni o'rtasidan 2 ga bo'lamiz — 625 dan.
				      Shu 0.88 × 0.625 dan doska yasaymiz. Shuning uchun ҳажм
				      UZUNLIKKA kirib ketadi.»

				   Ya'ni ЁЙИЛМА = doskaning UZUNLIGI (Ҳажми), kenglik esa listni
				   necha bo'lakka bo'lishdan chiqadi — chizmaga umuman bog'liq emas.

				     Ҳажми   = ёйилма / 1000
				     метр    = Ҳажми × Сони          (jami doska uzunligi)
				     рулон м = метр / 1.25 × кенглик  ( = метр ÷ N )
				     кв      = рулон м × 1.25

				   Tekshiruv: 0.88 × 40 = 35.2 m; 2b → N=2 → 17.6 rulon m → 22 kv.

				   Kenglik esa chizma oynasidagi «нечa бўлакка бўламиз» (1/2/3/4)
				   tanlovidan keladi va `draw_width` ga yoziladi — ya'ni bu yerda
				   `draw_width` = DOSKA KENGLIGI (rulon eni ÷ bo'lak), aksessuardagi
				   «sarf» emas. Nostandart doskada katalogda kenglik bo'lmaydi,
				   shuning uchun yagona manba shu. */
				if (payload.blank_mm > 0) p.element_quantity = payload.blank_mm / 1000
				p.draw_width = payload.draw_width      // doska kengligi, metrda
			} else {
				p.draw_width = payload.draw_width      // SARF, metrda — ombor shundan
			}
			// narxni qayta hisoblash uchun mavjud handlerni «bo'sh» hodisa bilan chaqiramiz
			dataCopy.products[drawModal.index] = p
			setData(dataCopy)
			/* ⚠️ `name: 'draw'` BO'LMASIN. handleChangeProduct() metrni FAQAT
			   `quantity` yoki `element_quantity` nomi bilan chaqirilganda qayta
			   hisoblaydi (:839). «draw» bilan chaqirilsa metr bo'sh qolib,
			   rulon-metr, narx va summa 0 bo'lib qolardi (2026-08-09).
			   Shuning uchun hajm nomi bilan chaqiramiz — u metrdan boshlab
			   butun zanjirni qayta hisoblaydi. */
			handleChangeProduct(drawModal.index, {
				target: { name: 'element_quantity', value: String(p.element_quantity ?? '') },
			})
			suggestNameForBlank(drawModal.index, p, payload.blank_mm)
		}
		setDrawModal({ show: false, index: -1 })
	}

	/* ═══ CHIZMA QAYSI NOMGA TO'G'RI KELADI ═══
	   Aksessuar nomlari kenglik tizimi: «Tarnov 2b» = rulon eniga 2 marta
	   sig'adi (1250÷2 = 625 mm rasxod), «3b» = 3 marta va h.k.
	   Demak chizma razvyortkasi nomni O'ZI aniqlaydi: 470 mm → 2b.
	   Sotuvchi noto'g'ri nomni tanlagan bo'lsa — mosini taklif qilamiz. */
	function suggestNameForBlank(index, p, blankMM) {
		/* ⚠️ TUNIKOFONDA ISHLAMAYDI: u yerda ёйилма — doskaning UZUNLIGI, rulon
		   eniga necha marta sig'ishi bilan aloqasi yo'q. Nom («2b») esa listni
		   necha bo'lakka bo'lishni bildiradi. Taklif qilinsa mutlaqo boshqa
		   mahsulotni tavsiya qilardi (2026-08-11). */
		if (isDoska(p)) return
		const rollWmm = Math.round((Number(p.length) || 1.25) * 1000)
		if (!blankMM || blankMM <= 0 || rollWmm <= 0) return
		const fits = Math.floor(rollWmm / blankMM + 1e-9)
		if (fits < 1) return
		const cur = p.product_name || ''
		const m = cur.match(/(\d+)\s*b\b/i)
		if (!m || Number(m[1]) === fits) return          // nom mos yoki «Nb» tizimida emas

		const wanted = cur.replace(/(\d+)\s*b\b/i, fits + 'b')
		/* ⚠️ `products.products` da FAQAT tur 1 («Продукт») bor — aksessuar ham,
		   tunikofon ham u yerda yo'q, shuning uchun mos nom hech qachon
		   topilmasdi va taklif umuman chiqmasdi. Qator turiga qarab kerakli
		   ro'yxatdan qidiramiz (2026-08-11). */
		const pool = p.product_type === 5 ? products?.tunicophones : products?.accessories
		const found = (pool || [])
			.find(x => String(x.name || '').trim().toLowerCase() === wanted.trim().toLowerCase())
		if (!found) return

		if (window.confirm(t('suggest_name_q', { blank: Math.round(blankMM), from: cur, to: found.name }))) {
			handleChangeProductSelect(index, 'product_id', found)
		}
	}

	function addReadyRow() {
		const idx = data.products.length
		addToList()
		setTimeout(() => setModalSelectProduct({ show: true, index: idx, key: 'product_id' }), 250)
	}

	async function getClientTypes() {
		const response = await GET('/helper/clients-types', {}, { loader: true })
		if (httpOk(response)) setClientTypes(response.data)
	}

	async function toggleUserModal(bool) {
		if (!clientTypes.length) await getClientTypes()
		if (bool) {
			setModalUser({ ...modalUser, show: true, name: '', phine: '', client_type_id: '', birthday: '', gender: 1, note: '' })
		} else {
			setModalUser({ show: false })
		}
	}

	function selectClient(item) {
		setData({
			...data,
			client_id: item.id,
			client_name: item.name,
			client_phone: item.phone,
			client_balance: item.balance,
			region_id: item.region_id ?? null,
		})
	}

	async function toggleSearchUserModal(bool, item = {}) {
		if (bool) {
			setModalSearchUser({ ...modalUser, show: true, })
		} else {
			setData({
				...data,
				client_id: item.id,
				client_name: item.name,
				client_phone: item.phone,
				client_balance: item.balance,
				region_id: item.region_id ?? null,
			});
			setModalSearchUser({ show: false })
		}
	}

	async function createUser(e) {
		e.preventDefault();

		var response;
		if (modalUser.id) {
			response = await PUT('/clients', modalUser, { loader: true })
		} else {
			response = await POST('/clients', modalUser, { loader: true })
		}

		if (httpOk(response)) {
			// Yangi qo'shilgan mijozni zakaz oynasida DARROV tanlaymiz — qayta qidirib topish shart emas.
			// (faqat yangi yaratishda; tahrirlashda joriy tanlov o'zgarmasin)
			if (!modalUser.id && response.data?.id) {
				const newClient = { ...response.data, balance: response.data.balance ?? 0 }
				setClients(prev => [newClient, ...prev])
				selectClient(newClient)
			}
			getClients()
			setModalUser({ show: false })
		}
	}

	function handleInputUserChange(e) {
		var modalUserCopy = { ...modalUser }
		modalUserCopy[e.target.name] = e.target.value
		setModalUser(modalUserCopy)
	}

	function handleInputChange(e) {
		var dataCopy = { ...data }
		dataCopy[e.target.name] = e.target.value;
		setData(dataCopy)
	}

	/* Aksessuar chizma shablonlari — aksessuar tanlanganda avtomat yuklash uchun.
	   ⚠️ Marshrut `sec.accessory_drawing` middleware bilan yopilgan. Ruxsati yo'q
	      tenantda (12 tadan 11 tasi) Kassa HAR ochilganda 403 xato toasti chiqardi.
	      Ruxsat bo'lmasa shablon ham kerak emas — umuman so'ramaymiz. */
	async function getAccTemplates() {
		if (!canDraw) return
		const response = await GET('/accessory-templates')
		if (httpOk(response)) setAccTemplates(response.data || [])
	}

	async function getProducts(dataCopy = false) {
		var response = await GET('/helper/products')
		if (httpOk(response)) { // avval tekshiruv — xato javobda crash bo'lmasin
			for (let i = 0; i < (response.data.allPreparedProducts ?? []).length; i++) {
				var index = -1;
				const preparedProduct = response.data.allPreparedProducts[i]
				if (preparedProduct.product_type === 3) {
					index = response.data.accessories.findIndex(item => item.product_id === preparedProduct.product_id)
					response.data.accessories.splice(index, 0, response.data.allPreparedProducts[i]);
				} if (preparedProduct.product_type === 4) {
					index = response.data.shapes.findIndex(item => item.product_id === preparedProduct.product_id)
					response.data.shapes.splice(index, 0, response.data.allPreparedProducts[i]);
				} if (preparedProduct.product_type === 5) {
					index = response.data.tunicophones.findIndex(item => item.product_id === preparedProduct.product_id)
					response.data.tunicophones.splice(index, 0, response.data.allPreparedProducts[i]);
				}
			}
			setProducts(prev => ({ ...prev, ...response.data }))
			if (dataCopy) {
				setTimeout(() => {
					calculateTotalAmount(dataCopy);
				}, 600);
			}
		};
	}

	async function getChequeStatuses() {
		const response = await GET('/helper/cheques-statuses')
		// Nom tarjimadan (baza jadvali global va faqat kirillcha) — helpers.js
		if (httpOk(response)) setChequeStatuses(response.data.map(s => ({
			...s,
			name: chequeStatusName(t, s.id, s.name),
		})))
	}

	async function getClients() {
		const response = await GET('/helper/clients')
		if (httpOk(response)) setClients(response.data)
	}

	async function getRegions() {
		const response = await GET('/regions')
		if (httpOk(response)) setRegions(response.data)
	}

	// Yassi hudud ro'yxatidan react-select variantlari (yo'l bilan: Chem — Andijon › Andijon shahri)
	/* Yangi hudud qo'shish. Saqlangach ro'yxat yangilanadi va yangi hudud
	   chekka O'ZI tanlanadi — sotuvchi qayta qidirmasin. */
	async function saveRegion() {
		const nom = String(regionModal.name || '').trim()
		if (!nom) { toast.error(t('name') + '?'); return }
		if (regionModal.type !== 'viloyat' && !regionModal.parent_id) {
			toast.error(t('region') + '?'); return
		}
		const response = await POST('/regions', {
			name: nom,
			type: regionModal.type,
			parent_id: regionModal.type === 'viloyat' ? null : regionModal.parent_id,
		}, { loader: true })
		if (!httpOk(response)) return
		toast.success(t('success'))
		const list = await GET('/regions')
		if (httpOk(list)) {
			setRegions(list.data)
			// yangi qo'shilganini topib, chekka darrov qo'yamiz
			const yangi = (list.data || []).find(r =>
				String(r.name).trim().toLowerCase() === nom.toLowerCase() &&
				String(r.type) === String(regionModal.type))
			if (yangi) setData(d => ({ ...d, region_id: yangi.id }))
		}
		setRegionModal({ show: false, name: '', type: 'zona', parent_id: null })
	}

	function regionOptions() {
		const byId = {}
		regions.forEach(r => { byId[r.id] = r })
		return regions.map(r => {
			const path = []
			let cur = r
			while (cur && cur.parent_id && byId[cur.parent_id]) { cur = byId[cur.parent_id]; path.unshift(cur.name) }
			return { value: r.id, name: r.name, path: path.join(' › '), type: r.type }
		})
	}

	async function getDeliveryTypes() {
		const response = await GET('/helper/delivery-types')
		if (httpOk(response)) setDeliveryTypes(response.data)
	}

	async function getCurrentCurrency() {
		const response = await GET('/current-currency')
		if (httpOk(response)) setCurrentCurrency(response.data)
	}


	async function getData() {
		const response = await GET(`/cheques/${id}`)
		if (httpOk(response)) {
			for (let i = 0; i < response.data.products.length; i++) {
				var product = response.data.products[i];
				if (product['product_type'] === 4 || product['product_type'] === 3 || product['product_type'] === 5) {
					product['metr'] = (product['quantity'] ?? 0) * (product['element_quantity'] ?? 0);
					if (product['percentage']) {
						product['metr'] =
							((product['element_quantity'] * product['quantity'])) +
							(product['element_quantity'] * product['quantity']) *
							(product['percentage'] / 100);
					}
				}
				if (product['is_prepared']) {
					product['accessory_total_price'] = Math.round((Number(product['accessory_sale_price']) * Number(product['quantity'])))
					product['accessory_sale_price_metr'] = Math.round(product['accessory_sale_price'])

					if (product['product_type'] === 4) {
						product['metr'] = product['quantity'];
					}

				} else if (product['product_type'] === 3 || product['product_type'] === 5) {
					/* ═══ MAVJUD QATOR MUZLATILADI (2026-08-11) ═══
					   MUAMMO: eski chekni ochib, HECH NARSAGA TEGMASDAN «Saqlash»
					   bosilsa ham summa o'zgarib ketardi — bu yerda jami saqlangan
					   narxdan QAYTA hisoblanardi, lekin birlik noto'g'ri edi:
					   tur 3 da `sale_price` rulon metriga yozilgan, ko'paytiruvchi
					   esa `metr` olinardi (~4 barobar farq).
					   O'lchangan (lokal baza): tur 3 — 3 972 qatordan 50 tasi
					   siljirdi (+1.7%), tur 5 — 2 521 dan 18 tasi (−1.3%).

					   ⚠️ Bu bug HEAD da ham bor, ya'ni HOZIR SERVERDA ishlayapti.

					   YECHIM — jami BAZADAGISI bo'lib qoladi, birlik narx esa
					   o'sha jamidan teskari chiqariladi. `is_price_manual = true`
					   narxni katalogdan qayta hisoblashni to'xtatadi, lekin jami
					   baribir miqdordan qayta chiqadi (:985 qo'riqchidan tashqarida) —
					   ya'ni foydalanuvchi Сони ni o'zgartirsa summa mutanosib
					   o'zgaradi, tegmasa esa tiyin ham siljimaydi. */
					const storedTotal = Number(product['total_price'] ?? 0)
					const metrNum = Number(product['metr'] ?? 0)
					const rollNum = Number(product['roll_metr'] ?? 0)

					// Katalog narxi/ustamasi keyin o'zgarsa ham bu qator ergashmasin
					product['is_price_manual'] = true

					if (product['product_type'] === 5) {
						product['kv_metr'] = rollNum * Number(product['length'] ?? 0)
					}

					// JAMI — bazadagisi. Hech qanday qayta hisob YO'Q.
					product['accessory_total_price'] = storedTotal

					/* Birlik narx saqlangan jamidan teskari chiqariladi — shunda
					   ko'rsatilgan narx × miqdor = ko'rsatilgan jami bo'ladi.
					   Bo'luvchi 0 bo'lsa (juda eski qatorda `roll_metr` yozilmagan —
					   tur 3 da 1 214 ta shunday qator bor) saqlangan birlik narx
					   o'zgarishsiz olinadi. */
					const unitBase = product['product_type'] === 5
						? Number(product['kv_metr'] ?? 0)
						: rollNum
					product['accessory_sale_price'] = unitBase > 0
						? Math.round(storedTotal / unitBase)
						: Number(product['sale_price'] ?? 0)
					product['accessory_sale_price_metr'] = metrNum > 0
						? Math.round(storedTotal / metrNum)
						: Math.round(Number(product['sale_price'] ?? 0))
				}
				if (product['element_id']) {
					product['element_balance_id'] = product['balance_id']
				}
			}
			response.data.paymentsCopy = structuredClone(data.payments)
			response.data.payments = structuredClone(data.payments).map(type => {
				// ₴ qarz-inkassa qatorlarini (is_debt_payment=true) tahrir shabloniga OLMAYMIZ —
				// aks holda ular naqd/bank shabloniga ko'chib, saqlashda dublikat to'lov + fantom
				// mijoz krediti + smena naqdi 2× bo'ladi (KRITIK-1). Ular bazada tegilmay qoladi.
				const payment = response.data.payments.find(p => p.payment_type_id === type.payment_type_id
					&& !(p.is_debt_payment === true || p.is_debt_payment === 1 || p.is_debt_payment === '1' || p.is_debt_payment === 't'));
				if (payment) {
					return {
						...type,
						amount: payment.amount,
						amount_usd: type.is_usd && Number(response.data.currency ?? currentCurrency) > 0
							? Math.ceil(payment.amount / Number(response.data.currency ?? currentCurrency))
							: 0,
					};
				} else {
					return {
						...type,
						amount: 0,
						amount_usd: 0,
					};
				}
			})

			if (response.data.currency) setCurrentCurrency(response.data.currency)
			calculateTotalAmount(response.data)
		}
	}

	useEffect(() => {
		getProducts()
		getAccTemplates()
		getClients()
		getRegions()
		getChequeStatuses()
		getDeliveryTypes()

		if (id) {
			getData()
		} else {
			if (location.state?.parent_id) {
				// Qo'shimcha zakaz — eski mahsulotlarni olmaydi, faqat mijoz va parent_id
				getCurrentCurrency()
			} else if (reduxTransferData?.chequeData?.products?.length > 0) {
				setData(structuredClone(reduxTransferData.chequeData))
				getCurrentCurrency()
			} else {
				getCurrentCurrency()
			}
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const products = getProductsList(); // берём текущий список
		if (modalSelectProduct.show) {
			const handleKeyDown = (e) => {
				switch (e.key) {
					case "ArrowUp": // вверх
						e.preventDefault();
						setActiveRowIndex(prev => prev > 0 ? prev - 1 : products.length - 1);
						break;
					case "ArrowDown": // вниз
						e.preventDefault();
						setActiveRowIndex(prev => prev < products.length - 1 ? prev + 1 : 0);
						break;
					case "Enter": // Enter
						e.preventDefault();
						const item = products[activeRowIndex];
						if (!item) break;   // T7: aktiv qator yo'q bo'lsa crash (products[undefined]) bo'lmasin
						handleChangeProductSelect(
							modalSelectProduct.index,
							modalSelectProduct.key,
							item   // T8: Enter ham sichqoncha kabi BUTUN obyektni uzatsin (aks holda qator nomsiz/narxsiz qoladi)
						);
						break;
					default:
						break;
				}
			};

			document.addEventListener('keydown', handleKeyDown);
			return () => {
				document.removeEventListener('keydown', handleKeyDown);
			};
		} else {
			if (activeRowIndex >= 0) {
				setActiveRowIndex(0)   // T7: undefined qoldirmaymiz — keyingi Enter da products[undefined] crash bermasin
			}
		}
	}, [modalSelectProduct.show, activeRowIndex, modalSelectProduct, getProductsList]); // eslint-disable-line react-hooks/exhaustive-deps


	useDidMountEffect(() => {
		calculateTotalAmount(data)
	}, [data.delivery_price]); // eslint-disable-line react-hooks/exhaustive-deps

	function getDataProducts() {
		if (!data.products.length) {
			return [];
		}
		var products = [...data.products]
		for (let i = 0; i < products.length; i++) {
			var item = products[i];
			item.show = false;
			if (activeTab === 1 && item.product_type === 4) {
				item.show = true;
			}
			if (activeTab === 2 && item.product_type === 3) {
				item.show = true;
			}
			if (activeTab === 3 && item.product_type === 1) {
				item.show = true;
			}
			if (activeTab === 4 && item.product_type === 5) {
				item.show = true;
			}
		}

		return products;
	}

	function getProductsList() {
		var arr = []
		if (!modalSelectProduct.show) return arr;

		if (activeTab === 1) {
			arr = products.shapes;
		}
		if (activeTab === 2) {
			arr = products.accessories;
		}
		if (activeTab === 3) {
			arr = products.products;
		}
		if (activeTab === 4) {
			arr = products.tunicophones;
		}
		if (modalSelectProduct.is_prepared) {
			arr = products.allPreparedProducts;
		}

		if (activeTab === 1) {
			arr = arr.filter(item => item.product_type === 4 && item.is_prepared)
		}
		if (activeTab === 2) {
			arr = arr.filter(item => item.product_type === 3 && item.is_prepared)
		}
		if (activeTab === 3) {
			arr = arr.filter(item => item.product_type === 1 && item.is_prepared)
		}
		if (activeTab === 4) {
			arr = arr.filter(item => item.product_type === 5 && item.is_prepared)
		}

		if ((activeTab === 1 || activeTab === 2 || activeTab === 4) && modalSelectProduct.key === 'element_id') {
			arr = modalSelectProduct.children
		}

		if (modalSelectProduct.search) {
			arr = arr.filter(item =>
				item.name.toLowerCase().includes(modalSelectProduct.search.toLowerCase()) ||
				(item.element_name && item.element_name.toLowerCase().includes(modalSelectProduct.search.toLowerCase()))
			);
		}

		return arr;
	}


	function getClientsList() {
		var arr = [...clients]

		if (modalSearchUser.search) {
			arr = arr.filter(item =>
				item?.name?.toLowerCase()?.includes(modalSearchUser.search?.toLowerCase()) ||
				item?.phone?.toLowerCase()?.includes(modalSearchUser.search?.toLowerCase())
			);
		}

		return arr;
	}

	function isButtonDisabled(isSave = false) {
		if (!data.products.length) {
			return true;
		}

		// Qarz ham hisobga olinadi: pul endi chek yozilganda kiritilmaydi (₴ tugmasi orqali olinadi),
		// shuning uchun yangi chekda paid har doim 0 bo'ladi. Faqat paid/discount tekshirilsa,
		// chop etish tugmalari doim o'chiq qolardi.
		if (data.paid <= 0 && data.discount_amount <= 0 && data.debt_amount <= 0) {
			return true;
		}

		if (!data.client_id) {
			return true;
		}

		// if (data.status === 3 && isSave) {
		// 	return true;
		// }

		return false;
	}

	return (
		<>
			<div className="d-flex gap-2">
				<div className="payment-left">
					<div className="p-2">
						{data.parent_id && !id &&
							<div className="alert alert-warning py-1 px-2 mb-2 d-flex align-items-center gap-2" style={{ fontSize: '0.85rem' }}>
								<i className="uil-link"></i>
								<span><b>#{data.parent_id}</b> ga qo'shimcha zakaz</span>
							</div>
						}
						{data.parent_id && id &&
							<div className="alert alert-warning py-1 px-2 mb-2 d-flex align-items-center gap-2" style={{ fontSize: '0.85rem' }}>
								<i className="uil-link"></i>
								<span><b>#{data.parent_id}</b> ga qo'shimcha zakaz — Bu <b>#{data.parent_id}-{data.cheque_suffix}</b></span>
							</div>
						}
						{!data.parent_id && data.cheque_suffix === 'A' &&
							<div className="alert alert-success py-1 px-2 mb-2 d-flex align-items-center gap-2" style={{ fontSize: '0.85rem' }}>
								<i className="uil-link"></i>
								<span>Bu <b>#{data.id}-A</b> asosiy chek — qo'shimcha zakazlari mavjud</span>
							</div>
						}
						<div className="d-between">
							<div className="tabs mb-3">
								<div className={`tab ${activeTab === 1 ? 'active' : ''}`} onClick={() => setActiveTab(1)}>
									{t('profiled_sheeting')}
								</div>
								<div className={`tab ${activeTab === 2 ? 'active' : ''}`} onClick={() => setActiveTab(2)}>
									{t('accessory')}
								</div>
								<div className={`tab ${activeTab === 4 ? 'active' : ''}`} onClick={() => setActiveTab(4)}>
									{t('tunikofon')}
								</div>
								<div className={`tab ${activeTab === 3 ? 'active' : ''}`} onClick={() => setActiveTab(3)}>
									{t('products')}
								</div>
							</div>

							{(!id && data?.products?.length > 0) &&
								<button className="btn btn-outline-danger" onClick={() => setModalConfirm({ show: true })}>
									<div className="d-between gap-2">
										<i className="uil-times"></i>
										{t('clear')}
									</div>
								</button>
							}
						</div>

						<div className="cashbox-products">
							{/* ═══ CHEREPITSA UMUMIY BOSHI/SHAG ═══ (2026-08-27, egasi:
							    «10 xil razmer bo'lsa har biriga yozish noqulay — umumiy
							    qilaylik, o'zida ham o'zgartirish imkoni qolsin»).
							    Faqat kamida bitta tile paneli ochiq bo'lganda ko'rinadi —
							    oddiy profnastil sotuvida jadval tepasi toza qoladi.
							    Qiymat kiritilishi bilan OCHIQ panelli hamma qatorga yoziladi;
							    keyin ochilgan qatorlar ham shu qiymatdan boshlab keladi. */}
							{activeTab === 1 && (data.products || []).some(p => isTileOpen(p)) &&
								<div className="d-flex align-items-center gap-1 flex-wrap px-2 py-1 mb-1"
									style={{ fontSize: 12, border: '1px dashed var(--dk-border, #dee2e6)', borderRadius: 4 }}>
								{/* Tez tugmalar OLIB TASHLANDI — egasi: «podskazkani olib
									    tashla, katakcha tursa yetadi» (tepada ham, pastda ham). */}
									<b className="me-1">{t('tile_common_label')}:</b>
									<span className="text-muted">{t('tile_start')}:</span>
									<input type="text" autoComplete="off" className="form-control form-control-sm d-inline-block"
										style={{ width: 56, height: 24, fontSize: 11.5, padding: '0 4px' }}
										value={tileDefault.start}
										onChange={(e) => applyTileDefault('start', e.target.value)} />
									<span className="text-muted ms-2">{t('tile_step')}:</span>
									<input type="text" autoComplete="off" className="form-control form-control-sm d-inline-block"
										style={{ width: 56, height: 24, fontSize: 11.5, padding: '0 4px' }}
										value={tileDefault.step}
										onChange={(e) => applyTileDefault('step', e.target.value)} />
									<span className="text-muted">{t('sm_unit')}</span>
								</div>}
							{activeTab === 1 &&
								<table className="table table-bordered">
									<thead>
										<tr>
											<th style={{ minWidth: '33px' }} className="text-center">№</th>
											<th style={{ width: '25%' }}>{t('corrugated')}</th>
											<th style={{ width: '25%' }}>{t('roll')}</th>
											<th style={{ width: '5%' }} className="text-center">{t('party')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('balance2')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('size')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('quantity')}</th>
											<th style={{ width: '7%' }} className="text-end">{t('metr')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('price')}</th>
											<th style={{ width: '20%' }} className="text-end">{t('amount')}</th>
											<th style={{ minWidth: '33px' }} className="text-end"></th>
										</tr>
									</thead>
									<tbody>
										{getDataProducts()?.map((item, index) => (
											item.show &&
											<tr key={index}>
												<td style={{ height: '35px' }} className="text-center">{index + 1}</td>
												<td className="p-0">
													<div className="position-relative">
														<Select
															classNamePrefix="border-none bs-none"
															options={products.shapes.filter(item => !item.is_prepared)}
															value={products.shapes.find(option => (option.product_id === item.product_id && option.is_prepared === item.is_prepared)) ?? ''}
															onChange={(option) => handleChangeProductSelect(index, 'product_id', option)}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => `${option.name} ${option?.balance_id ? `(${option.balance})` : ''}`}
															getOptionValue={(option) => `${option.product_id} ${option.is_prepared}`}
															openMenuOnFocus={true}

														/>
													</div>
													{/* ═══ CHEREPITSA: BOSHI + SHAG ═══ (2026-08-28)
													    Boshi (5/8) + Shag (35/38/39) — chekda (mijoz + sex topshirig'i)
													    ko'rinadi. FAQAT cherepitsa (is_tile) mahsulotda chiqadi — egasi
													    boshqa shakllarda ko'rinmasin dedi. Belgilash: Mahsulot kartasidagi
													    «Cherepitsa» galochkasi (products.is_tile). */}
													{isTileOpen(item) &&
														<div className="px-1 pb-1 pt-1" style={{ borderTop: '1px dashed var(--dk-border, #dee2e6)' }}>
															<div className="d-flex align-items-center gap-1 flex-wrap" style={{ fontSize: 11.5 }}>
																<span className="text-muted">{t('tile_start')}:</span>
																<input type="text" autoComplete="off" className="form-control form-control-sm d-inline-block"
																	style={{ width: 52, height: 22, fontSize: 11, padding: '0 4px' }}
																	value={item.tile_start_sm ?? ''}
																	onChange={(e) => handleChangeProduct(index, { target: { name: 'tile_start_sm', value: e.target.value } })} />
																<span className="text-muted ms-1">{t('tile_step')}:</span>
																<input type="text" autoComplete="off" className="form-control form-control-sm d-inline-block"
																	style={{ width: 52, height: 22, fontSize: 11, padding: '0 4px' }}
																	value={item.tile_step_sm ?? ''}
																	onChange={(e) => handleChangeProduct(index, { target: { name: 'tile_step_sm', value: e.target.value } })} />
																<span className="text-muted">{t('sm_unit')}</span>
															</div>
															{/* UZUNLIK MOSLIGI (egasining tanlovi: ogohlantirsin, BLOKLAMASIN).
															    (uzunlik_sm − boshi) shag'ga butun bo'linishi kerak — aks holda
															    list to'lqin o'rtasidan kesiladi. Eng yaqin to'g'ri uzunliklar taklif qilinadi. */}
															{(() => {
																if (item.tile_start_sm === null || item.tile_start_sm === undefined || item.tile_start_sm === '' ||
																	item.tile_step_sm === null || item.tile_step_sm === undefined || item.tile_step_sm === '') return null
																const lenSm = Number(item.element_quantity) * 100
																const st = Number(item.tile_start_sm), sh = Number(item.tile_step_sm)
																if (!(lenSm > 0) || !(st >= 0) || !(sh > 0)) return null
																const rem = (lenSm - st) % sh
																if (Math.abs(rem) < 0.5 || Math.abs(rem - sh) < 0.5) return null
																const nLow = Math.floor((lenSm - st) / sh)
																const low = ((st + nLow * sh) / 100).toFixed(2)
																const high = ((st + (nLow + 1) * sh) / 100).toFixed(2)
																return (
																	<div style={{ fontSize: 10.5, color: '#d97706', marginTop: 2 }}>
																		<i className="uil-exclamation-triangle" /> {t('tile_len_mismatch', { len: Number(item.element_quantity), low: low, high: high })}
																	</div>
																)
															})()}
														</div>}
												</td>
												<td className="p-0">
													<div className="position-relative" onKeyDownCapture={(e) => handleRollCategoryKeyDown(e, index)}>
														<Select
															classNamePrefix="border-none bs-none"
															isDisabled={item.is_prepared}
															options={products.categories}
															value={item.is_prepared ? { name: item.element_name, balance_id: item.element_balance_id } : products?.rolls?.find(option => (option.balance_id === item.element_balance_id)) ?? ''}
															// value={products?.categories?.find(option => option.id === item.element_id)}
															onChange={(option) => setModalSelectProduct({ show: true, index: index, key: 'element_id', children: option.products })}
															openMenuOnFocus={true}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) =>
																`${option.name}
																 ${(option?.products?.length > 0 || option.balance > 0) ?
																	`(${option?.products?.length ? option.products.length : formatMoney(option.balance)})`
																	:
																	''
																}`
															}
															getOptionValue={(option) => option.balance_id}
															ref={(el) => (rollSelectRefs.current[index] = el)}

														/>
														<i className="uil-ellipsis-h custom-select-btn" role="button" tabIndex={0}
															title="Partiya tanlash (Enter)"
															onClick={() => setModalSelectProduct({ show: true, index: index, key: 'element_id', children: products.rolls })}
															onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setModalSelectProduct({ show: true, index: index, key: 'element_id', children: products.rolls }); } }} />
													</div>
												</td>
												<td className="text-center">{formatDate(item.created_at)}</td>
												<td className={`text-end ${isOverStock(item) ? 'bg-danger text-white' : ''}`}>
													<b>
														{item.actual_balance != null ? formatMoney(item.actual_balance) : formatMoney(item.balance)}
													</b>
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off" name="element_quantity" value={formatMoneyInput(item.element_quantity)}
														onChange={(e) => handleChangeProduct(index, e)} disabled={item.is_prepared}
														ref={(el) => { refs.current[index] = el; sizeRefs.current[index] = el; }} />
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off" name="quantity" value={formatMoneyInput(item.quantity)}
														onChange={(e) => handleChangeProduct(index, e)} ref={(el) => inputRefs.current[index] = el} />
												</td>
												<td className="text-end">
													{formatMoney(item.metr, 3)}
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off"
														name="sale_price"
														value={formatMoneyInput(item.sale_price)}
														onChange={(e) => handleChangeProduct(index, e)}
														onKeyDown={(e) => onKeyPress(e, index)}
													/>
												</td>
												<td className="text-end">
													{formatMoney(item.sale_price * item.metr)}
												</td>
												<td>
													{(!item.id || checkPermission('cashbox.delete_product')) &&
														<div className="d-flex justify-content-center" onClick={() => toggleModalDelete(true, item, index)}>
															<i className="uil-times-circle fz-20 cursor text-danger"></i>
														</div>
													}
												</td>
											</tr>
										))
										}
									</tbody>
									<tfoot>
										<tr>
											<td></td>
											<td colSpan={1} style={{ 'padding': 0 }}>
												<div className="d-flex gap-1">
													<button type="button" className="btn-sm btn-primary" style={{ flex: 1 }}
														onClick={() => addToList()}>
														✂️ {t('add')}
													</button>
													<button type="button" className="btn-sm btn-success" style={{ flex: 1 }}
														onClick={() => addReadyRow()}>
														📦 Tayyor
													</button>
												</div>
											</td>
											<td className="fw-bold">
												{t('total')}
											</td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[4]?.metr, 3)}</td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[4]?.amount)}</td>
											<td></td>
										</tr>
									</tfoot>
								</table>
							}
							{activeTab === 2 &&
								<table className="table table-bordered">
									<thead>
										<tr>
											<th style={{ minWidth: '33px' }} className="text-center">№</th>
											<th style={{ width: '25%' }}>{t('accessory')}</th>
											<th style={{ width: '25%' }}>{t('roll')}</th>
											<th style={{ width: '5%' }} className="text-center">{t('party')}</th>
											{/* CHIZMA — 2026-08-08 */}
											{showDrawCol && <th style={{ width: '6%' }} className="text-center">{t('drawing')}</th>}
											<th style={{ width: '4%' }} className="text-end">{t('width')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('balance2')}</th>
											<th style={{ width: '4%' }} className="text-end">{t('size')}</th>
											<th style={{ width: '4%' }} className="text-end">{t('quantity')}</th>
											<th style={{ width: '4%' }} className="text-end">{t('metr')}</th>
											<th style={{ width: '4%', minWidth: '70px' }} className="text-end" title="Метр / Длина * Ширина">
												{t('roll_m')}
											</th>
											<th style={{ width: '6%' }} className="text-end">
												<CustomTooltip text="(Цена продажи рулона + Наценка) * Рулон М / Метр">
													{t('price')}
												</CustomTooltip>
											</th>
											<th style={{ width: '10%' }} className="text-end" title={`${t('price')} * ${t('roll_m')}`}>{t('amount')}</th>
											<th style={{ minWidth: '33px' }} className="text-end"></th>
										</tr>
									</thead>
									<tbody>
										{getDataProducts()?.map((item, index) => (
											item.show &&
											<tr key={index}>
												<td style={{ height: '35px' }} className="text-center">{index + 1}</td>
												<td>
													<div className="position-relative">
														<Select
															ref={(el) => (productSelectRefs.current[index] = el)}
															classNamePrefix="border-none bs-none"
															options={products.accessories.filter(item => !item.is_prepared)}
															value={products.accessories.find(option => (option.product_id === item.product_id && option.is_prepared === item.is_prepared)) ?? ''}
															onChange={(option) => handleChangeProductSelect(index, 'product_id', option)}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => `${option.name} ${option?.balance_id ? `(${option.balance})` : ''}`}
															getOptionValue={(option) => `${option.product_id} ${option.is_prepared}`}
															openMenuOnFocus={true}
														/>
													</div>
												</td>
												<td>
													<div className="position-relative" onKeyDownCapture={(e) => handleRollCategoryKeyDown(e, index)}>
														<Select
															classNamePrefix="border-none bs-none"
															isDisabled={item.is_prepared}
															options={products.categories}
															value={item.is_prepared ? { name: item.element_name } : products?.rolls?.find(option => (option.balance_id === item.element_balance_id)) ?? ''}
															// value={products?.categories?.find(option => option.id === item.element_id)}
															onChange={(option) => handleChangeCategoriesSelect(index, option)}
															openMenuOnFocus={true}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) =>
																`${option.name}
																 ${(option?.products?.length > 0 || option.balance > 0) ?
																	`(${option?.products?.length ? option.products.length : formatMoney(option.balance)})`
																	:
																	''
																}`
															}
															getOptionValue={(option) => option.balance_id}
															ref={(el) => (rollSelectRefs.current[index] = el)}
														/>
														<i className="uil-ellipsis-h custom-select-btn" role="button" tabIndex={0}
															title="Partiya tanlash (Enter)"
															onClick={() => setModalSelectProduct({ show: true, index: index, key: 'element_id', children: products.rolls })}
															onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setModalSelectProduct({ show: true, index: index, key: 'element_id', children: products.rolls }); } }} />
													</div>
												</td>
												<td className="text-center">{formatDate(item.created_at)}</td>
												{/* CHIZMA — shablondan tanlash yoki mijoz oldida chizish */}
												{showDrawCol &&<td className="text-center text-nowrap">
													{/* Chizma bo'lsa DOIM ko'rsatiladi (tarif tushsa ham eski chek
													    rasmi yo'qolmasin), lekin YANGI chizish faqat modul bor tenantда */}
													{item.draw_png
														? <img src={item.draw_png} alt="" title={t('drawing')}
															style={{ width: '54px', height: '34px', objectFit: 'contain', cursor: canDraw ? 'pointer' : 'default', border: '1px solid #dee2e6', borderRadius: '4px' }}
															onClick={() => canDraw && openDrawing(index)} />
														: canDraw
														? <button type="button" className="btn btn-sm btn-outline-primary py-0 px-2"
															style={{ fontSize: '11.5px' }} onClick={() => openDrawing(index)}>
															✎ {t('draw')}
														</button>
														: <span className="text-muted">—</span>
													}
												</td>}
												<td className="text-end">
													{item.draw_width
														? <><span className="text-primary fw-bold">{Math.round(item.draw_width * 1000)}</span>
															<span className="d-block text-muted" style={{ fontSize: '10.5px', lineHeight: 1.2 }}>
																{t('by_drawing')}</span></>
														: item.width}
												</td>
												<td className={`text-end ${isOverStock(item) ? 'bg-danger text-white' : ''}`}>
													<b>
														{item.actual_balance != null ? formatMoney(item.actual_balance) : formatMoney(item.balance)}
													</b>
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off" name="element_quantity" value={formatMoneyInput(item.element_quantity)}
														disabled={item.is_prepared} onChange={(e) => handleChangeProduct(index, e)}
														ref={(el) => { refs.current[index] = el; sizeRefs.current[index] = el; }} />
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off" name="quantity" value={formatMoneyInput(item.quantity)}
														onChange={(e) => handleChangeProduct(index, e)} ref={(el) => inputRefs.current[index] = el} />
												</td>
												<td className="text-end">{formatMoney(item.metr, 3)}</td>
												<td className="text-end">{formatMoney(item.roll_metr, 3)}</td>
												{/* <td className="text-end">{formatMoney(item.accessory_sale_price / item.metr)}</td> */}
												<td className="td-input">
													<input type="text" autoComplete="off"
														name="accessory_sale_price_metr"
														value={formatMoneyInput(item.accessory_sale_price_metr)}
														onChange={(e) => handleChangeProduct(index, e)}
														onKeyDown={(e) => onKeyPress(e, index)} />
												</td>
												<td className="text-end">{formatMoney(item.accessory_total_price)}</td>
												<td>
													{(!item.id || checkPermission('cashbox.delete_product')) &&
														<div className="d-flex justify-content-center" onClick={() => toggleModalDelete(true, item, index)}>
															<i className="uil-times-circle fz-20 cursor text-danger"></i>
														</div>
													}
												</td>
											</tr>
										))
										}
									</tbody>
									<tfoot>
										<tr>
											<td></td>
											<td colSpan={1} style={{ 'padding': 0 }}>
												<div className="d-flex gap-1">
													<button type="button" className="btn-sm btn-primary" style={{ flex: 1 }}
														onClick={() => addToList(1)}>
														✂️ {t('add')}
													</button>
													<button type="button" className="btn-sm btn-success" style={{ flex: 1 }}
														onClick={() => addReadyRow()}>
														📦 Tayyor
													</button>
												</div>
											</td>
											<td className="fw-bold">
												{t('total')}
											</td>
											{/* CHIZMA ustuni qo'shilgani uchun bitta katak ko'p */}
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[3]?.metr, 3)}</td>
											<td className="text-end fw-bold">{formatMoney(data?.total[3]?.roll_metr, 3)}</td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[3]?.amount)}</td>
											<td></td>
										</tr>
									</tfoot>
								</table>
							}
							{activeTab === 3 &&
								<table className="table table-bordered">
									<thead>
										<tr>
											<th style={{ minWidth: '33px' }} className="text-center">№</th>
											<th style={{ width: '25%' }}>{t('product')}</th>
											<th style={{ width: '10%' }} className="text-end">{t('balance2')}</th>
											<th style={{ width: '10%' }}>{t('unit')}</th>
											<th style={{ width: '30%' }}></th>
											<th style={{ width: '6%' }} className="text-end">{t('quantity')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('price')}</th>
											<th style={{ width: '15%' }} className="text-end">{t('amount')}</th>
											<th style={{ minWidth: '33px' }} className="text-end"></th>
										</tr>
									</thead>
									<tbody>
										{getDataProducts()?.map((item, index) => (
											item.show &&
											<tr key={index}>
												<td style={{ height: '35px' }} className="text-center">{index + 1}</td>
												<td>
													<div className="position-relative">
														{/* {JSON.stringify(item.is_prepared)} */}
														<Select
															classNamePrefix="border-none bs-none"
															options={products.products}
															value={item.is_prepared ? { name: `${item.name} [ ${item.element_name} ]` } : products.products.find(option => option.product_id === item.product_id) ?? ''}
															// value={products.products.find(option => option.product_id === item.product_id) ?? ''}
															onChange={(option) => handleChangeProductSelect(index, 'product_id', option)}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => option.name}
															getOptionValue={(option) => option.product_id}
															openMenuOnFocus={true}
															ref={(el) => (refs.current[index] = el)}
														/>
														<i className="uil-ellipsis-h custom-select-btn"
															onClick={() => setModalSelectProduct({ show: true, is_prepared: true, index: index, key: 'product_id' })} />
													</div>
												</td>
												<td className="text-end">
													<b>{item.balance}</b>
												</td>
												<td>{item.unit_name}</td>
												<td></td>
												<td className={`td-input ${!item.quantity && 'danger'}`}>
													<input type="text" autoComplete="off" name="quantity" value={item.quantity}
														onChange={(e) => handleChangeProduct(index, e)} />
												</td>
												<td className={`td-input ${!item.sale_price && 'danger'}`}>
													<input type="text" autoComplete="off" name="sale_price" value={item.sale_price}
														onChange={(e) => handleChangeProduct(index, e)}
														onKeyDown={(e) => onKeyPress(e, index)} />
												</td>
												<td className="text-end">
													{formatMoney(item.sale_price * item.quantity)}
												</td>
												<td>
													{(!item.id || checkPermission('cashbox.delete_product')) &&
														<div className="d-flex justify-content-center" onClick={() => toggleModalDelete(true, item, index)}>
															<i className="uil-times-circle fz-20 cursor text-danger"></i>
														</div>
													}
												</td>
											</tr>
										))
										}
									</tbody>
									<tfoot>
										<tr>
											<td></td>
											<td colSpan={1} style={{ 'padding': 0 }}>
												<button type="button" className="btn-sm btn-primary w-100" onClick={() => addToList(1)}>
													{t('add')}
												</button>
											</td>
											<td className="fw-bold">{t('total')}</td>
											<td></td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[1]?.quantity, 3)}</td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[1]?.amount)}</td>
											<td></td>
										</tr>
									</tfoot>
								</table>
							}
							{activeTab === 4 &&
								<table className="table table-bordered">
									<thead>
										<tr>
											<th style={{ minWidth: '33px' }} className="text-center">№</th>
											<th style={{ width: '25%' }}>{t('accessory')}</th>
											<th style={{ width: '25%' }}>{t('roll')}</th>
											<th style={{ width: '5%' }} className="text-center">{t('party')}</th>
											{/* CHIZMA — aksessuardagi bilan AYNAN bir xil (2026-08-11) */}
											{showDrawCol && <th style={{ width: '6%' }} className="text-center">{t('drawing')}</th>}
											<th style={{ width: '4%' }} className="text-end">{t('width')}</th>
											<th style={{ width: '6%' }} className="text-end">{t('balance2')}</th>
											<th style={{ width: '4%' }} className="text-end">{t('size')}</th>
											<th style={{ width: '4%' }} className="text-end">{t('quantity')}</th>
											<th style={{ width: '4%', minWidth: '70px' }} className="text-end" title="Метр / Длина * Ширина">{t('roll_m')}</th>
											<th style={{ width: '4%', minWidth: '70px' }} className="text-end" title="Метр / Длина * Ширина">{t('sq_m')}</th>
											<th style={{ width: '6%' }} className="text-end" >
												<CustomTooltip text="(Цена прихода + Наценка) * Длина">
													{t('price')}
												</CustomTooltip>
											</th>
											<th style={{ width: '10%' }} className="text-end" title={`${t('price')} * ${t('sq_m')}`}>{t('amount')}</th>
											<th style={{ minWidth: '33px' }} className="text-end"></th>
										</tr>
									</thead>
									<tbody>
										{getDataProducts()?.map((item, index) => (
											item.show &&
											<tr key={index}>
												<td style={{ height: '35px' }} className="text-center">{index + 1}</td>
												<td>
													<div className="position-relative">
														<Select
															classNamePrefix="border-none bs-none"
															options={products?.tunicophones?.filter(item => !item.is_prepared)}
															value={products.tunicophones.find(option => (option.product_id === item.product_id && option.is_prepared === item.is_prepared)) ?? ''}
															onChange={(option) => handleChangeProductSelect(index, 'product_id', option)}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) => `${option.name} ${option?.balance_id ? `(${option.balance})` : ''}`}
															getOptionValue={(option) => `${option.product_id} ${option.is_prepared}`}
															openMenuOnFocus={true}
															ref={(el) => (refs.current[index] = el)}
														/>
													</div>
												</td>
												<td>
													<div className="position-relative" onKeyDownCapture={(e) => handleRollCategoryKeyDown(e, index)}>
														<Select
															classNamePrefix="border-none bs-none"
															isDisabled={item.is_prepared}
															options={products.categories}
															value={products?.rolls?.find(option => option.balance_id === item.element_balance_id) ?? ''}
															// value={products?.categories?.find(option => option.id === item.element_id)}
															onChange={(option) => setModalSelectProduct({ show: true, index: index, key: 'element_id', children: option.products }) ?? ''}
															placeholder=""
															noOptionsMessage={() => t('list_empty')}
															getOptionLabel={(option) =>
																`${option.name}
																 ${(option?.products?.length > 0 || option.balance > 0) ?
																	`(${option?.products?.length ? option.products.length : formatMoney(option.balance)})`
																	:
																	''
																}`
															}
															getOptionValue={(option) => option.balance_id}
															ref={(el) => (rollSelectRefs.current[index] = el)}
														/>
														<i className="uil-ellipsis-h custom-select-btn" role="button" tabIndex={0}
															title="Partiya tanlash (Enter)"
															onClick={() => setModalSelectProduct({ show: true, index: index, key: 'element_id', children: products.rolls })}
															onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setModalSelectProduct({ show: true, index: index, key: 'element_id', children: products.rolls }); } }} />
													</div>
												</td>
												<td className="text-center">{formatDate(item.created_at)}</td>
												{/* CHIZMA — aksessuar jadvalidagi bilan AYNAN bir xil xulq */}
												{showDrawCol &&
													<td className="text-center text-nowrap">
														{item.draw_png
															? <img src={item.draw_png} alt="" title={t('drawing')}
																style={{ width: '54px', height: '34px', objectFit: 'contain', cursor: canDraw ? 'pointer' : 'default', border: '1px solid #dee2e6', borderRadius: '4px' }}
																onClick={() => canDraw && openDrawing(index)} />
															: canDraw
															? <button type="button" className="btn btn-sm btn-outline-primary py-0 px-2"
																style={{ fontSize: '11.5px' }} onClick={() => openDrawing(index)}>
																✎ {t('draw')}
															</button>
															: <span className="text-muted">—</span>
														}
													</td>}
												{/* Chizmada «нечa бўлакка» tanlangan bo'lsa DOSKA KENGLIGI
												    shundan chiqadi — katalognikini emas, o'shani ko'rsatamiz */}
												<td className="text-end">
													{item.draw_width > 0
														? <b className="text-primary" title={t('size_from_drawing')}>{item.draw_width}</b>
														: item.width}
												</td>
												<td className={`text-end ${isOverStock(item) ? 'bg-danger text-white' : ''}`}>
													<b>
														{item.actual_balance != null ? formatMoney(item.actual_balance) : formatMoney(item.balance)}
													</b>
												</td>
												{/* ⚠️ TUNIKOFONDA «Ҳажми» — doska uzunligi.
												    FAQAT NOSTANDARTDA qulflanadi (u yerda uzunlik chizmadan keladi).
												    Standart shablonda ёйилма faqat OLDINDAN to'ldiriladi — uzunlik
												    buyurtmaga qarab o'zgaradi, shuning uchun yozish mumkin. */}
												<td className="td-input">
													<input type="text" autoComplete="off" name="element_quantity" value={formatMoneyInput(item.element_quantity)}
														disabled={item.is_prepared || (!!item.draw_json && !!item.needs_drawing)}
														title={item.draw_json && item.needs_drawing ? t('size_from_drawing') : ''}
														onChange={(e) => handleChangeProduct(index, e)}
														ref={(el) => (sizeRefs.current[index] = el)} />
												</td>
												<td className="td-input">
													<input type="text" autoComplete="off" name="quantity" value={formatMoneyInput(item.quantity)}
														onChange={(e) => handleChangeProduct(index, e)} ref={(el) => inputRefs.current[index] = el} />
												</td>
												<td className="text-end">{formatMoney(item.roll_metr, 3)}</td>
												<td className="text-end">{formatMoney(item.kv_metr, 3)}</td>
												<td className="td-input">
													<input type="text"
														autoComplete="off"
														name="accessory_sale_price"
														value={formatMoneyInput(item.accessory_sale_price)}
														onChange={(e) => handleChangeProduct(index, e)}
														onKeyDown={(e) => onKeyPress(e, index)} />
												</td>
												<td className="text-end">{formatMoney(item.accessory_total_price)}</td>
												<td>
													{(!item.id || checkPermission('cashbox.delete_product')) &&
														<div className="d-flex justify-content-center" onClick={() => toggleModalDelete(true, item, index)}>
															<i className="uil-times-circle fz-20 cursor text-danger"></i>
														</div>
													}
												</td>
											</tr>
										))
										}
									</tbody>
									<tfoot>
										<tr>
											<td></td>
											<td colSpan={1} style={{ 'padding': 0 }}>
												<div className="d-flex gap-1">
													<button type="button" className="btn-sm btn-primary" style={{ flex: 1 }}
														onClick={() => addToList(1)}>
														✂️ {t('add')}
													</button>
													<button type="button" className="btn-sm btn-success" style={{ flex: 1 }}
														onClick={() => addReadyRow()}>
														📦 Tayyor
													</button>
												</div>
											</td>
											<td className="fw-bold">
												{t('total')}
											</td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											{/* «Чизма» ustuni qo'shilgani uchun bitta bo'sh katak ortdi —
											    bo'lmasa jamlanma raqamlari boshqa ustunga siljib qolardi */}
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[5]?.roll_metr, 3)}</td>
											<td className="text-end fw-bold">{formatMoney(data?.total[5]?.kv_metr, 3)}</td>
											<td></td>
											<td className="text-end fw-bold">{formatMoney(data?.total[5]?.amount)}</td>
											<td></td>
										</tr>
									</tfoot>
								</table>
							}
						</div>
					</div>
					<div className="bottom-btn">

						<div className="d-between align-items-end gap-3">
							<div className="w-75">
								<div className="d-flex gap-3 mb-2">
									<div className="w-100">
										<label>{t('client')}<span className="required-mark">*</span></label>
										<div className="position-relative">
											<Select
												className="bottom-select"
												menuPlacement='top'
												classNamePrefix="bottom-select"
												options={clients}
												value={clients?.find(option => option.id === data.client_id)}
												onChange={(option) => selectClient(option)}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												formatOptionLabel={(option, { context }) => {
													const bal = Number(option.balance)
													const badge = bal < 0
														? <span className="text-danger fw-600" style={{ whiteSpace: 'nowrap' }}>{t('debt')}: {formatMoney(Math.abs(bal))}</span>
														: bal > 0
															? <span className="text-success" style={{ whiteSpace: 'nowrap' }}>{t('advance')}: {formatMoney(bal)}</span>
															: null
													// Tanlangan qiymat: nom yonida inline (dropdown ikonasi bilan urishmasin). Royxatda: nom chap, qarz ong.
													return context === 'value'
														? <span className="d-inline-flex align-items-center gap-2">{option.name}{badge}</span>
														: <div className="d-flex justify-content-between align-items-center gap-2"><span>{option.name}</span>{badge}</div>
												}}
												getOptionValue={(option) => option.id}
											/>
											<i className="uil-plus custom-select-btn" onClick={() => toggleUserModal(true)} />
											<i className="uil-search custom-select-btn" style={{ right: '75px' }} onClick={() => toggleSearchUserModal(true)} />
										</div>

									</div>
									<div className="w-100">
										<label>{t('status')}</label>
										<Select
											className="bottom-select"
											menuPlacement='top'
											classNamePrefix="bottom-select"
											options={chequeStatuses?.filter(option => option.id !== 3 || data.status === 3)}
											value={chequeStatuses?.find(option => option.id === data.status)}
											onChange={(option) => setData({ ...data, status: option.id })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>

									<div className="w-100">
										<label>{t('note')}</label>
										<input type="text" className="form-control small" value={data.note} onChange={(e) => setData({ ...data, note: e.target.value })} />
									</div>
								</div>

								<div className="d-flex gap-3 mb-2">
									<div className="w-100">
										<label className={!data.region_id ? 'text-danger fw-600' : ''}>
											{t('region')} <span className="text-danger">*</span>
										</label>
										{/* ⚠️ «+» — hudud MAJBURIY, lekin mijozning mahallasi ro'yxatda
										    bo'lmasligi mumkin. Ilgari sotuvchi chekni saqlay olmay egasiga
										    qo'ng'iroq qilardi; endi shu yerda qo'shadi (2026-08-11). */}
										{/* «+» — Мижоз maydonidagi bilan AYNAN bir xil uslub:
										    alohida tugma emas, select ICHIGA joylashtirilgan ikona
										    (`custom-select-btn`: absolute, right 45px). Ilgari yonida
										    alohida tugma turardi — u select balandligiga cho'zilib,
										    keraksiz katta ko'rinardi. */}
										<div className="position-relative">
											<Select
												className="bottom-select"
												menuPlacement='top'
												classNamePrefix="bottom-select"
												options={regionOptions()}
												value={regionOptions().find(o => o.value === data.region_id) || null}
												onChange={(o) => setData({ ...data, region_id: o?.value ?? null })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(o) => o.path ? `${o.name} — ${o.path}` : o.name}
												getOptionValue={(o) => o.value}
											/>
											<i className="uil-plus custom-select-btn" title={t('add')}
												onClick={() => setRegionModal({ show: true, name: '', type: 'zona', parent_id: null })} />
										</div>
									</div>
									<div className="w-100">
										<label style={(data.status === 2 || data.status === 3) && !data.delivery_date ? { color: '#dc3545', fontWeight: 600 } : {}}>
											{t('delivery_date')}
											{(data.status === 2 || data.status === 3) && <span className="text-danger ms-1">*</span>}
										</label>
										<div className="calendar-input">
											<DatePicker
												className={`form-control${(data.status === 2 || data.status === 3) && !data.delivery_date ? ' is-invalid' : ''}`
													/* Tavsiya tugmasi ko'rinsa — matnga o'ng tomondan joy ochiladi */
													+ ((canPlanDelivery && deliverySuggestion?.suggested_date && !data.delivery_date) ? ' has-suggest' : '')}
												selected={data.delivery_date ? new Date(data.delivery_date) : null}
												onChange={(date) => setData({
													...data,
													'delivery_date': formatDate(date, 'yyyy-MM-dd HH:mm'),
													'delivery_override_reason': null,
												})}
												onFocus={loadDeliverySuggestion}
												placeholderText={queueText}
												dateFormat="dd.MM.yyyy HH:mm"
												showTimeSelect
												timeIntervals={30}
												timeFormat="HH:mm"
												timeCaption={t('time')}
											/>
											{/* TAVSIYA — katakcha ICHIDA, kalendar belgisidan chapda.
											    Sana tanlangach yashiriladi (o'sha joyda endi sananing o'zi turadi).
											    `onMouseDown` to'xtatiladi: aks holda bosilganda avval maydon fokus
											    olib, kalendar ochilib ketardi va tugma bosilmay qolardi. */}
											{(canPlanDelivery && deliverySuggestion?.suggested_date && !data.delivery_date) &&
												<button type="button" className="dp-suggest"
													title={t('recommended')}
													onMouseDown={(e) => e.preventDefault()}
													onClick={applyDeliverySuggestion}>
													<i className="uil-bolt"></i>
													{formatDate(deliverySuggestion.suggested_date, 'dd.MM.yyyy')}
												</button>
											}
											<i className="uil uil-calendar-alt"></i>
										</div>

										{/* OGOHLANTIRISHLAR — navbat va tavsiya endi katakchaning ICHIDA.
										    Bu yerda faqat e'tibor talab qiladigan xabarlar qoladi. */}
										{(canPlanDelivery && (deliverySuggestion?.shortage?.has_shortage || deliverySuggestion?.day_load_warning)) &&
											<div className="fz-14 mt-1">
												{deliverySuggestion.shortage?.has_shortage &&
													<div className="text-warning">
														<i className="uil uil-exclamation-triangle me-1"></i>
														{t('delivery_stock_shortage')}
													</div>
												}
												{deliverySuggestion.day_load_warning &&
													<div className="text-warning">
														<i className="uil uil-exclamation-triangle me-1"></i>
														{t('delivery_day_busy', { n: deliverySuggestion.day_load })}
													</div>
												}
											</div>
										}
									</div>

									<div className="w-100">
										<label>{t('delivery_type')}</label>
										<Select
											isClearable
											options={deliveryTypes}
											value={deliveryTypes.find(option => option.id === data.delivery_type_id) || ''}
											onChange={(option) => setData({ ...data, 'delivery_type_id': option?.id, 'delivery_type_name': option?.name })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>

									<div className="w-100">
										<label>{t('delivery_price')}</label>
										<input type="text" className="form-control small" value={formatMoneyInput(data.delivery_price)}
											onChange={(e) => setData({ ...data, delivery_price: e.target.value.replace(/[^\d.]/g, '') })} />
									</div>

								</div>

								{/* Tўлов режаси — pul qanday keladi. Majburiy; qarz qoladigan rejalarda muddat ham so'raladi. */}
								<div className="d-flex gap-3 w-100 mb-2" style={{ alignItems: 'flex-end' }}>
									<div style={{ flex: 1, minWidth: 0 }}>
										<label className={!data.payment_plan ? 'text-danger fw-600' : ''}>
											{t('payment_plan')} <span className="text-danger">*</span>
										</label>
										<div style={{ display: 'flex', gap: '8px', flexWrap: 'nowrap' }}>
											{PAYMENT_PLANS.map(plan => (
												<button key={plan.key} type="button"
													style={{ flex: '1 1 0', whiteSpace: 'nowrap', minWidth: 0 }}
													className={`btn btn-sm ${data.payment_plan === plan.key ? 'btn-primary' : 'btn-outline-secondary'}`}
													onClick={() => setData({
														...data,
														payment_plan: plan.key,
														// Faqat Насия'da sana kerak; cash/half/driver — sanasiz (tozalanadi)
														debt_date: plan.key === 'nasiya' ? data.debt_date : null,
													})}>
													{plan.icon} {t(plan.i18n)}
												</button>
											))}
										</div>
									</div>

									{planNeedsDebtDate(data.payment_plan) &&
										<div style={{ flex: '0 0 175px', width: '175px' }}>
											<label className={!data.debt_date ? 'text-danger fw-600' : ''}>
												{t('nasiya_date')} <span className="text-danger">*</span>
											</label>
											<div className="calendar-input">
												<DatePicker
													className={`form-control small${!data.debt_date ? ' is-invalid' : ''}`}
													selected={data.debt_date ? new Date(data.debt_date) : null}
													onChange={(date) => setData({ ...data, debt_date: formatDate(date, 'yyyy-MM-dd') })}
													dateFormat="dd.MM.yyyy"
													placeholderText={t('nasiya_date')}
												/>
												<i className="uil uil-calendar-alt"></i>
											</div>
										</div>
									}

									{/* СКИДКА — pastdan shu yerga ko'chirildi.
									    "Qolganini to'ldirish" (💵) tugmasi ATAYIN yo'q: u yerda bir bosishda
									    butun chek bepul bo'lib ketardi. */}
									{discountIndex !== -1 &&
										<div style={{ flex: '0 0 150px', width: '150px' }}>
											<label>{data.payments[discountIndex]?.name}</label>
											<input type="text" className="form-control small text-end"
												value={formatMoneyInput(data.payments[discountIndex]?.amount)}
												onChange={(e) => handleChangePayment(discountIndex, e)} />
										</div>
									}
								</div>

								{/* Pastdagi to'lov qatori butunlay olib tashlandi:
								      Накд / Банк / P2P / Доллар — pul chek YOZILGANDA emas, OLINGANDA kiritiladi
								                                   (cheklar ro'yxatidagi ₴ "To'lov olish" tugmasi).
								      Насия                       — endi AVTOMATIK hisoblanadi (jami − to'langan),
								                                   kassir qo'lda yozmaydi.
								      Скидка                      — yuqoriga, "Тўлов режаси" qatoriga ko'chirildi. */}
							</div>

							<div className="h-100 w-25">
								<div className="mb-2">
									<div className="d-between fw-600 fz-20">
										<div>{t('to_pay')}</div>
										<div>{data.total_amount ? formatMoney(data.total_amount) : 0}</div>
									</div>
									<div className="d-between fw-600">
										<div>{t('discount')}</div>
										<div>{formatMoney(data.discount_amount)}</div>
									</div>
									{/* Eski chekni tahrirlaganda to'langan pul ko'rinsin (yangi chekda 0) */}
									{data.paid > 0 &&
										<div className="d-between fw-600">
											<div>{t('paid')}</div>
											<div className="text-success">{formatMoney(data.paid)}</div>
										</div>
									}
									{/* Насия — avtomatik. Pul ₴ tugmasi orqali olinadi. */}
									<div className="d-between fw-600 fz-18 pt-1 border-top mt-1">
										<div>{t('debt')}</div>
										<div className="text-danger">{formatMoney(data.debt_amount)}</div>
									</div>
								</div>

								<div className="d-flex h-100 gap-2 mb-2">
									<button className="btn btn-info" onClick={() => printCheque()} disabled={isButtonDisabled()}>
										<i className="uil-print fz-18"></i>
									</button>
									<button className="btn btn-info" onClick={() => printCheque(true)} disabled={isButtonDisabled()}>
										<i className="uil-print fz-18"></i> A4
									</button>
								</div>

								{data.status > 0 &&
									<div className="d-flex h-100 gap-2">
										<button className="btn btn-success" disabled={chequeSubmitting} onClick={() => createCheque()}>
											{t('save')}
										</button>
										{id && !data.parent_id &&
											<button className="btn btn-warning text-white" onClick={() => navigate('/cashbox/create', {
												state: {
													parent_id: Number(id),
													client_id: data.client_id,
													delivery_type_id: data.delivery_type_id,
													address: data.address,
												}
											})}>
												+ Qo'shimcha zakaz
											</button>
										}
									</div>
								}
							</div>
						</div>


					</div>

				</div>
			</div>

			<Cheque data={data} printChequeRef={printChequeRef} />

			<DeleteModal
				showNote={true}
				modalDelete={modalDelete}
				setModalDelete={toggleModalDelete}
				setNote={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>

			<DeleteModal
				modalDelete={modalConfirm}
				setModalDelete={() => setModalConfirm({ show: false })}
				deleteItem={clearData}>
			</DeleteModal>

			{/* AKSESSUAR va TUNIKOFON CHIZMA OYNASI */}
			{/* ═══ HUDUD QO'SHISH — kassadan ═══
			    Sotuvchi mijozning mahallasini ro'yxatda topmasa shu yerda qo'shadi.
			    Tahrirlash/o'chirish bu yerda YO'Q — u faqat Sozlamalarda (ega/direktor). */}
			<Modal show={regionModal.show} animation={false} centered
				onHide={() => setRegionModal({ ...regionModal, show: false })}>
				<Modal.Header closeButton>
					<Modal.Title style={{ fontSize: '17px' }}>{t('region')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group">
						<label>{t('type')}</label>
						<Select
							options={[
								{ id: 'viloyat', name: t('region_type_viloyat') },
								{ id: 'tuman', name: t('region_type_tuman') },
								{ id: 'zona', name: t('region_type_zona') },
							]}
							value={[
								{ id: 'viloyat', name: t('region_type_viloyat') },
								{ id: 'tuman', name: t('region_type_tuman') },
								{ id: 'zona', name: t('region_type_zona') },
							].find(o => o.id === regionModal.type)}
							onChange={(o) => setRegionModal({ ...regionModal, type: o?.id ?? 'zona', parent_id: null })}
							getOptionLabel={(o) => o.name} getOptionValue={(o) => o.id}
							placeholder="" noOptionsMessage={() => t('list_empty')} />
					</div>

					{regionModal.type !== 'viloyat' &&
						<div className="form-group mt-2">
							<label>{t('parent')} <span className="text-danger">*</span></label>
							{/* Yuqori hudud: zona uchun tuman, tuman uchun viloyat */}
							<Select
								options={regionOptions().filter(o =>
									regionModal.type === 'zona' ? o.type === 'tuman' : o.type === 'viloyat')}
								value={regionOptions().find(o => o.value === regionModal.parent_id) || null}
								onChange={(o) => setRegionModal({ ...regionModal, parent_id: o?.value ?? null })}
								getOptionLabel={(o) => o.path ? `${o.name} — ${o.path}` : o.name}
								getOptionValue={(o) => o.value}
								placeholder="" noOptionsMessage={() => t('list_empty')} />
						</div>}

					<div className="form-group mt-2">
						<label>{t('name')} <span className="text-danger">*</span></label>
						<input type="text" className="form-control" autoFocus
							value={regionModal.name}
							onChange={(e) => setRegionModal({ ...regionModal, name: e.target.value })}
							onKeyDown={(e) => { if (e.key === 'Enter') saveRegion() }} />
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => setRegionModal({ ...regionModal, show: false })}>{t('cancel')}</button>
						<button className="btn btn-primary w-100" onClick={saveRegion}>{t('save')}</button>
					</div>
				</Modal.Footer>
			</Modal>

			<DrawingModal
				show={drawModal.show}
				onHide={() => setDrawModal({ show: false, index: -1 })}
				onSave={onDrawingSaved}
				initial={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.draw_json : null}
				rollWidthM={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.length : 1.25}
				/* Narx bazasi ikkala turda ham rulonning SOTUV narxi — jadvaldagi
				   hisob bilan bir xil bo'lishi shart (Cashbox.js:871). */
				rollPriceSom={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.sale_price : 0}
				productType={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.product_type : 3}
				/* 1 = doska (chizma uzunlik + bo'linish), 2 = karniz (aksessuardek) */
				calcMode={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.calc_mode : null}
				/* Tunikofonda «нечa бўлак» tanlovining boshlang'ich qiymati shundan */
				productWidthM={drawModal.index >= 0
					? (data?.products?.[drawModal.index]?.draw_width ?? data?.products?.[drawModal.index]?.width)
					: null}
				markup={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.markup : 0}
				elementQuantity={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.element_quantity : 0}
				quantity={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.quantity : 0}
				rollRal={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.element_ral : null}
				rollName={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.element_name : null}
				productId={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.product_id : null}
				rollProductId={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.element_id : null}
				rollCats={products?.categories || []}
				rollSel={drawRoll}
				onRollSel={r => {
					// Jadvaldagi bilan AYNAN bir xil qoida: ochilmagan partiyani
					// sotuvchi tanlay olmaydi (rulonni usta/omborchi ochadi).
					if (r && !r.is_opened && !isBackorderRow(r)) { toast.error(t('roll_not_open')); return }
					setDrawRoll(r)
				}}
				/* Nom tanlansa — O'SHA nomning partiyalari, «⋯» bosilsa — hammasi.
				   Jadvaldagi handleRollCategoryKeyDown bilan bir xil mantiq. */
				onOpenRollPicker={cat => setModalSelectProduct({
					show: true, index: drawModal.index, key: 'element_id',
					children: (cat && Array.isArray(cat.products)) ? cat.products : products.rolls,
					forDraw: true,
				})}
				needsDrawing={drawModal.index >= 0 ? !!data?.products?.[drawModal.index]?.needs_drawing : false}
				markupTiers={drawModal.index >= 0 ? data?.products?.[drawModal.index]?.markup_tiers : null}
			/>

			<Modal show={modalSelectProduct.show} animation={false} restoreFocus={false} centered size="xl" dialogClassName="cashbox-product-modal"
				onHide={() => setModalSelectProduct({ ...modalSelectProduct, show: false })}>
				<Modal.Body>
					<div>
						<h5 className="mb-3 fw-bold">
							{modalSelectProduct.key === 'product_id' ? "📦 Tayyor ombordan tanlash" : "📋 Rulon (partiya) tanlash"}
						</h5>
						<div className="mb-2">
							<label>{t('search')}</label>
							<input autoFocus type="text" className="form-control"
								onChange={(e) => setModalSelectProduct({ ...modalSelectProduct, search: e.target.value })} />
						</div>

						<div style={{ minHeight: '500px', overflow: 'auto' }}>
							<table className="table table-bordered table-hover">
								<thead>
									<tr>
										<th style={{ width: '25%' }}>{t('name2')}</th>
										{modalSelectProduct.key === 'product_id' &&
											<>
												<th style={{ width: '10%' }}>{t('warehouse')}</th>
												<th style={{ width: '25%' }}>{t('roll')}</th>
												<th style={{ width: '10%' }} className="text-end">{t('balance2')}</th>
												<th style={{ minWidth: '75px' }}>{t('unit')}</th>
												<th style={{ width: '10%' }} className="text-end">{t('sale_price')}</th>
												<th style={{ minWidth: '125px' }} className="text-center">{t('created')}</th>
											</>
										}
										{modalSelectProduct.key === 'element_id' &&
											<>
												<th style={{ width: '5%' }}>{t('id')}</th>
												<th style={{ minWidth: '70px' }}>{t('unit')}</th>
												<th style={{ minWidth: '60px' }} className="text-end">{t('quantity')}</th>
												<th style={{ minWidth: '80px' }} className="text-end">{t('balance2')}</th>
												<th style={{ 'minWidth': '60px' }} className="text-end">
													<CustomTooltip text={`${t('quantity')} / 1200 * 1000`}>
														{t('1м-кг')}
													</CustomTooltip>
												</th>
												<th style={{ 'minWidth': '60px' }} className="text-end">
													<CustomTooltip text={`1200 / ${t('quantity')}`}>
														{t('1т-м')}
													</CustomTooltip>
												</th>
												<th style={{ minWidth: '115px' }} className="text-center">{t('date')}</th>
												<th style={{ width: '10%' }} className="td-ellipsis">{t('supplier')}</th>
												<th style={{ width: '10%' }}>{t('opened_by')}</th>
												<th style={{ minWidth: '125px' }} className="text-center">{t('opened_at')}</th>
												<th style={{ width: '10%' }} className="text-center">{t('status')}</th>
											</>
										}
									</tr>
								</thead>
								<tbody>
									{getProductsList().map((item, index) => (
										<tr key={index}
											className={`cursor ${index === activeRowIndex ? 'table-active' : ''}`}
											onClick={() => {
												if (modalSelectProduct.forDraw) {
													// chizma oynasi uchun tanlanyapti — qatorga tegmaymiz
													if (!item.is_opened && !isBackorderRow(item)) { toast.error(t('roll_not_open')); return }
													setDrawRoll(item)
													setModalSelectProduct({ ...modalSelectProduct, show: false })
													return
												}
												handleChangeProductSelect(modalSelectProduct.index, modalSelectProduct.key, item)
											}}>
											<td>
												{item.name}
												{modalSelectProduct.key === 'element_id' && isBackorderRow(item) &&
													<div className="text-secondary fz-12">
														{t('last_batch')}: {formatDate(item.created_at)} · {t('finished')}
													</div>
												}
											</td>
											{modalSelectProduct.key === 'product_id' &&
												<>
													<td>{item.wms_name}</td>
													<td>{item.element_name}</td>
													<td className="text-end">{formatMoney(item.balance, 3)}</td>
													<td>{item.unit_name}</td>
													<td className="text-end">{formatMoney(item.sale_price)}</td>
													<td className="text-center">{formatDate(item.prepared_at)}</td>
												</>
											}
											{modalSelectProduct.key === 'element_id' &&
												<>
													{/* QARZ qatorida ID / Сони / Сана / Очди / Очилган сана — tugagan ESKI
													    partiyaniki. Ular ko'rsatilsa sotuvchi kelayotgan rulonning ma'lumoti
													    deb o'qiydi, shuning uchun bo'sh qoladi. Ta'minotchi qoladi — u odatda
													    o'zgarmaydi. 1м-кг va 1т-м «≈» bilan: taxminiy tayanch, kelgan rulonda
													    tonna/metr nisbati boshqacha bo'lishi mumkin. */}
													<td>{isBackorderRow(item) ? '' : item.element_id}</td>
													<td>{item.unit_name}</td>
													<td className="text-end">{isBackorderRow(item) ? '' : item.quantity}</td>
													<td className="text-end">{formatMoney(item.actual_balance, 3)}</td>
													<td className="text-end text-nowrap vertical-middle">
														{isBackorderRow(item) && item.quantity ? '≈ ' : ''}
														{item.quantity ? formatMoney(Number(item.original_quantity ?? 0) / item.quantity * 1000, 2) : 0}
													</td>
													<td className="text-end text-nowrap vertical-middle">
														{isBackorderRow(item) && item.quantity ? '≈ ' : ''}
														{item.quantity ? formatMoney(item.quantity / Number(item.original_quantity)) : 0}
													</td>
													<td className="text-center">{isBackorderRow(item) ? '' : formatDate(item.created_at)}</td>
													<td className="td-ellipsis">{item.supplier_name}</td>
													<td>{isBackorderRow(item) ? '' : item.opened_by}</td>
													<td className="text-center">{isBackorderRow(item) ? '' : formatDate(item.opened_at, "dd.MM.yyyy HH:mm")}</td>
													{/* Holat. Qoldig'i 0 bo'lgan partiya «Очиқ» ko'k badge bilan oddiy
													    mavjud partiyaday ko'rinmasligi kerak — sotuvchi bu sotuv «Rulon
													    qarzi»ga tushishini oldindan bilishi kerak. */}
													{isBackorderRow(item)
														? <td className="text-center text-white bg-warning">{t('roll_backorder')}</td>
														: <td className={`text-center text-white ${item.is_opened ? 'bg-info' : 'bg-primary'}`}>
															{item.is_opened ? t('open') : t('new')}
														</td>
													}
												</>
											}
										</tr>
									))}

								</tbody>
							</table>
						</div>
					</div>
				</Modal.Body>
			</Modal>

			<Modal show={modalSearchUser.show} animation={false} centered size="lg"
				onHide={() => setModalSearchUser({ ...modalSearchUser, show: false })}>
				<Modal.Body>
					<div className="addition-wrapper no-scroll">
						<div className="mb-2">
							<label>{t('search')}</label>
							<input autoFocus type="text" className="form-control"
								onChange={(e) => setModalSearchUser({ ...modalSearchUser, search: e.target.value })} />
						</div>

						<div>
							<table className="table table-bordered table-hover">
								<thead>
									<tr>
										<th style={{ width: '20%' }}>{t('name')}</th>
										<th style={{ width: '5%' }}>{t('phone')}</th>
										<th style={{ width: '20%' }}>{t('note')}</th>
										<th style={{ width: '20%' }}>{t('address')}</th>
										<th style={{ width: '15%' }} className="text-end">{t('debt')}</th>
										<th style={{ width: '15%' }} className="text-end">{t('number_of_checks')}</th>
									</tr>
								</thead>
								<tbody>
									{getClientsList().map((item, index) => (
										<tr className="cursor" key={index} onClick={() => toggleSearchUserModal(false, item)}>
											<td>{item.name}</td>
											<td>{item.phone}</td>
											<td>{item.note}</td>
											<td>{item.address}</td>
											<td className="text-end">{formatMoney(item.balance)}</td>
											<td className="text-end">{formatMoney(item.count_cheques)}</td>
										</tr>
									))
									}
								</tbody>
							</table>
						</div>
					</div>
				</Modal.Body>
			</Modal>

			<Modal show={modalQuantity.show} animation={false}
				centered size="sm"
				onHide={() => setModalQuantity({ ...modalQuantity, show: false })}>
				<Modal.Header closeButton>
					<Modal.Title>{modalQuantity.name}</Modal.Title>
				</Modal.Header>


				<Modal.Body>
					<form onSubmit={(e) => addProductType2(e)}>
						<div>
							<label htmlFor="quantity">{t('quantity')}</label>
							<input
								id="quantity"
								type="text"
								className="form-control"
								autoFocus
								onChange={(e) => setModalQuantity({ ...modalQuantity, quantity: e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>

						<hr />

						<div className="d-flex gap-2 w-100">
							<button className="btn btn-warning w-100" type="button"

								onClick={() => setModalQuantity({ ...modalQuantity, show: false })}>
								{t('cancel')}
							</button>

							<button className="btn btn-primary w-100" type="submit">
								{t('confirm')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>

			<Modal show={modalUser.show} animation={false}
				centered size="md"
				onHide={() => setModalUser({ ...modalUser, show: false })}>
				<Modal.Header closeButton>
					<Modal.Title>
						{modalUser.id ?
							<>{t('edit')}</>
							:
							<>{t('create')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUser(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('name')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={modalUser.name ?? ''}
								onChange={(e) => handleInputUserChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('phone')}</label>
							<input type="number" className="form-control" name="phone"
								value={modalUser.phone ?? ''}
								onChange={(e) => handleInputUserChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('client_types')}</label>
							<Select
								isClearable
								options={clientTypes}
								value={clientTypes.find(option => option.id === modalUser.client_type_id) || ''}
								onChange={(option) => setModalUser({ ...modalUser, 'client_type_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="form-group">
							<label>{t('birthday')}</label>
							<input type="date" className="form-control" name="birthday"
								value={modalUser.birthday ?? ''}
								onChange={(e) => handleInputUserChange(e)} />
						</div>
						<div className="d-flex justify-content-between mb-2">
							<div className="d-flex gap-3">
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setModalUser({ ...modalUser, 'gender': 1 })}
										style={{ 'backgroundColor': modalUser.gender === 1 ? 'black' : '' }}>
									</div>
									<span onClick={() => setModalUser({ ...modalUser, 'gender': 1 })}>
										{t('man')}
									</span>
								</div>

								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setModalUser({ ...modalUser, 'gender': 2 })}
										style={{ 'backgroundColor': modalUser.gender === 2 ? 'black' : '' }}>
									</div>
									<span onClick={() => setModalUser({ ...modalUser, 'gender': 2 })}>
										{t('woman')}
									</span>
								</div>
							</div>
						</div>

						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								value={modalUser.note ?? ''}
								onChange={(e) => handleInputUserChange(e)} />
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleUserModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>


			<Modal show={modalDebtDate.show} animation={false} centered size="md"
				onHide={() => setModalDebtDate({ show: false })}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('debt_payment_date')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex gap-2">
						<div className="form-group w-25">
							<label>{t('days')}</label>
							<input
								type="text"
								name="debt_days"
								className="form-control"
								onChange={handleChange}
								value={data?.debt_days ?? ""}
								disabled={data.debt_date ? false : true}
							/>
						</div>

						<div className="w-100">
							<label>{t('date')}</label>
							<div className="calendar-input">
								<DatePicker
									className="form-control"
									selected={data.debt_date ? new Date(data.debt_date) : null}
									onChange={(date) => setData({
										...data,
										'debt_date': formatDate(date, 'yyyy-MM-dd'),
										'debt_date_original': formatDate(date, 'yyyy-MM-dd')
									})}
									dateFormat="dd.MM.yyyy"
								/>
								<i className="uil uil-calendar-alt"></i>
							</div>
						</div>
						{/* <div className="form-group w-100">
							<label>{t('date')}</label>
							<MaskedInput
								name="debt_date"
								mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/]}
								className="form-control"
								guide={true}
								onChange={handleChange}
								value={data?.debt_date ?? ""}
							/>
						</div> */}
					</div>
					{/* <div className="d-flex gap-2">
						<div className="form-group w-100">
							<label>{t('days')}</label>
							<input
								className="form-control"
								guide={true}
								onChange={handleChange}
							// value={data?.debt_date ?? ""}
							/>
						</div>
						<div className="form-group w-100">
							<label>{t('hours')}</label>
							<input
								className="form-control"
								guide={true}
								onChange={handleChange}
							// value={data?.debt_date ?? ""}
							/>
						</div>
					</div> */}

					<div className="d-flex gap-2 w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => setModalDebtDate({ show: false })}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100" onClick={() => createCheque(false)}>{t('save')}</button>
					</div>

				</Modal.Body>
			</Modal>

			{/* <Modal show={modalDelivery.show} animation={false}
				centered size="md"
				onHide={() => setModalDelivery({ ...modalDelivery, show: false })}>
				<Modal.Header closeButton>
					<Modal.Title>{t('delivery')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createDeliveryType(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('address')}</label>
							<input type="text" className="form-control" name="address"
								value={modalDelivery.address ?? ''}
								onChange={(e) => handleInputDeliveryChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('delivery_date')}</label>
							<div className="calendar-input">
								<DatePicker
									className="form-control"
									selected={modalDelivery.delivery_date ? new Date(modalDelivery.delivery_date) : null}
									onChange={(date) => setModalDelivery({
										...modalDelivery,
										'delivery_date': formatDate(date, 'yyyy-MM-dd HH:mm')
									})}
									dateFormat="dd.MM.yyyy HH:mm"
									showTimeSelect
									timeIntervals={30}
									timeFormat="HH:mm"
									timeCaption={t('time')}
								/>
								<i className="uil uil-calendar-alt"></i>
							</div>
						</div>

						<div className="form-group">
							<label>{t('delivery_type')}</label>
							<Select
								isClearable
								options={deliveryTypes}
								value={deliveryTypes.find(option => option.id === modalDelivery.delivery_type_id) || ''}
								onChange={(option) => setModalDelivery({ ...modalDelivery, 'delivery_type_id': option?.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setModalDelivery({ ...modalDelivery, show: false })}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('confirm')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal> */}
		</>
	)
}

export default Cashbox